<template>
  <div class="app_box">
    <div class="tab_tag_">
      <div class="tab_tag_s">
        <div class="tab_tag_slider" :class="{ 'is-right': picked_id == 2 }"></div>
        <div class="tab_tag" :class="{ tag_picked_css: picked_id == 1 }" @click="picked_id = 1">
          自动识别
        </div>
        <div class="tab_tag" :class="{ tag_picked_css: picked_id == 2 }" @click="picked_id = 2">
          手动检索
          <el-tooltip class="item tab_tag_tip" effect="dark" content="若需求自动识别有误，可通过切换手动检索来补充需求" placement="top">
            <i class="el-icon-warning" @click.stop></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="app_css" v-if="picked_id == 1">
      <div class="chat-layout" :class="{
        'layout-top': !tab_or && identifyList.length > 0,
        'is-composer-fullscreen': composerFullscreen,
      }">
        <div class="chat-content data_css" :class="tab_or
          ? 'bottom_list_css'
          : !tab_or && identifyList.length > 0
            ? 'top_list_css'
            : 'bottom_list_css'
          ">
          <div class="identify_list_css" v-if="!tab_or && identifyList.length > 0">
            <h2 class="tit_txt">识别结果</h2>
            <div class="identify_li_s">
              <div class="identify_li_css" v-for="(item, index) in identifyList" :key="index">
                <van-swipe-cell>
                  <div class="li_css">
                    <el-checkbox class="checkbox_col" v-model="item.checked" :disabled="item.disabled"
                      @change="checked_change(index)"></el-checkbox>
                    <div class="li_box">
                      <div class="li_box_tag">
                        <el-tag size="medium" @click="edit_demand(item, index)">{{
                          item.name
                        }}</el-tag>
                        <el-tag size="medium" @click="priority_edit(index)">{{
                          item.priority
                        }}</el-tag>
                        <el-tag size="medium" @click="remarkEdit(item, index)">{{
                          item.remark.length > 0 ? "已备注" : "备注"
                        }}</el-tag>
                        <span v-if="item.resultMsg == ' ✔ 提交成功'" style="
                          color: green;
                          font-size: 12px;
                          display: inline-block;
                        ">{{ item.resultMsg }}</span>
                        <span v-else style="
                          color: red;
                          font-size: 12px;
                          display: inline-block;
                        ">{{
                          item.resultMsg.length > 20
                            ? " ✘ 提交失败"
                            : item.resultMsg
                        }}</span>
                      </div>
                      <div class="li_box_txt">
                        {{ item.text }}
                      </div>
                    </div>
                    <div class="li_btn">
                      <img src="../../../assets/imgs/app/edit.png" @click="edit_demand(item, index)" alt="" />
                      <img src="../../../assets/imgs/app/arrow_left.png" style="width: 21px; margin-left: 10px"
                        alt="" />
                    </div>
                  </div>
                  <template #right>
                    <!-- <van-button square type="danger" text="删除" />
                  <van-button square type="primary" text="编辑" /> -->
                    <div class="right_css">
                      <div class="right_btn" style="background: #f56c6c" @click="del_demand(item, index)">
                        删除
                      </div>
                      <div class="right_btn" style="
                        background: #67c23a;
                        border-start-end-radius: 5px;
                        border-end-end-radius: 5px;
                      " @click="edit_demand(item, index)">
                        编辑
                      </div>
                    </div>
                  </template>
                </van-swipe-cell>
              </div>
            </div>
            <div class="footer_submit" v-if="identifyList.length > 0">
              <div class="clear_result" @click="clear_result">清空结果</div>
              <div class="merge_result" @click="merge_demand">需求合并</div>
              <div class="sumbit_selected" @click="handleSelect">提交</div>
            </div>
          </div>
          <div class="ai_css" v-if="tab_or || (!tab_or && identifyList.length <= 0)">
            <div class="message_list_css" id="myDiv" @scroll="onScroll" ref="myDiv" :style="myDivStyle">
              <div style="width: 800px;margin: auto;" class="message_list_css_inner">

              
              <div class="down_css" :class="{ 'is-active': down_loading }" v-loading="down_loading"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0)"></div>
              <div v-for="(item, index) in messageData" :key="item.id || `msg-${index}`">
                <div class="time_css" v-if="firstIndex_s(item.date_time) == index">
                  {{ item.date_time }}
                </div>
                <div class="message_li_css" :style="item.types == 1 ? 'justify-content: flex-end;' : ''">
                  <!-- <img style="
                    width: 40px;
                    height: 40px;
                    position: relative;
                    left: -5px;
                  " v-if="item.types !== 1" src="../../../assets/imgs/app/robot_icon.png" alt="" /> -->
                  <div class="msg_txt_" :class="{ 'msg_txt_--user': item.types == 1 }" :style="item.types == 1
                    ? 'max-width: calc(100% - 50px);min-width: 70px'
                    : 'max-width: calc(100% - 50px);'
                    ">
                    <!--  -->
                    <div class="ai-reply-header"
                      v-if="item.types !== 1 && !hasEmergencyMessage(item) && !(item.message.quote && item.message.quote.task_id)">
                      <span class="ai-reply-badge">AI助手回复</span>
                      <span v-if="shouldShowAiResultReturn(item)" class="ai-result-return">结果返回</span>
                    </div>
                    <div v-if="item.types == 2" class="msg_txt_css">
                      <div class="wenxian_" v-if="
                        item.message.processing &&
                        item.message.processing.length > 0
                      ">
                        <div class="analysis-result">
                          <div class="analysis-head">
                            <p class="analysis-title">需求解析已完成</p>
                            <span
                              class="analysis-time"
                              v-if="getAnalysisHeadTime(item)"
                            >{{ getAnalysisHeadTime(item) }}</span>
                          </div>
                          <button class="details-toggle" type="button"
                            :aria-expanded="isProcessingDetailsOpen(item) ? 'true' : 'false'"
                            @click="toggleProcessingDetails(item)">
                            <span>已识别{{ item.message.processing.length }}条需求</span>
                            <i class="el-icon-arrow-right chevron"></i>
                          </button>
                          <div class="details-list-wrap" :class="{ 'is-open': isProcessingDetailsOpen(item) }">
                            <ul class="details-list">
                              <li v-for="(val, idx) in item.message.processing" :key="idx">
                                <span class="details-list-label">{{ getDemandCodeLabel(val.demand_code) }}：</span><span
                                  class="details-list-value" v-html="val.content"></span>
                              </li>
                            </ul>
                          </div>
                          <p class="result-note" v-if="!isValidJSON(item.message.text)"
                            v-html="formatMultilineText(item.message.text)"></p>
                        </div>
                      </div>

                      <div v-if="item.message.quote && item.message.quote.task_id"
                        class="quote-reply-block quote-reply-block--assistant">
                        <div class="ai-reply-header">
                          <span class="ai-reply-badge">AI助手回复</span>
                          <span class="ai-result-return">结果返回</span>
                        </div>
                        <p v-if="item.message.text" class="ai-reply-status">
                          <span class="ai-reply-status-main">{{
                            getAiReplyMainText(item.message.text)
                          }}</span><span v-if="getAiReplyHintText(item.message.text)" class="ai-reply-status-hint">{{
                              getAiReplyHintText(item.message.text) }}</span>
                        </p>
                        <div class="quote-source quote-source--ref">
                          <span class="quote-source-bar" aria-hidden="true"></span>
                          <div class="quote-source-body">
                            <p class="quote-source-line" v-if="item.message.quote.demand_code">
                              <span class="quote-source-label">需求类型：</span>
                              <span class="quote-source-value">{{
                                getDemandCodeLabel(item.message.quote.demand_code)
                              }}</span>
                            </p>
                            <p class="quote-source-line" v-if="item.message.quote.content">
                              <span class="quote-source-label">需求内容：</span>
                              <span class="quote-source-value">{{
                                item.message.quote.content
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="result-card-list" v-if="item.message.success && item.message.success.length > 0">
                        <template v-for="(val, index) in item.message.success">
                          <article v-if="isEmergencyMessage(val)" class="manual-reply-card"
                            :key="'manual-success-' + index">
                            <span v-if="isManualAssistantReply(val)" class="manual-reply-badge">人工助手回复</span>
                            <span v-else class="manual-reply-badge manual-reply-badge--consultant">图书馆参考咨询员</span>
                            <div class="manual-reply-panel">
                              <div class="manual-quote-source">
                                <span class="quote-source-bar" aria-hidden="true"></span>
                                <div class="manual-quote-content">
                                  <p v-if="val.demand_code" class="manual-quote-line">
                                    <span class="manual-quote-label">需求类型：</span>
                                    <span class="manual-quote-value">{{
                                      getDemandCodeLabel(val.demand_code)
                                    }}</span>
                                  </p>
                                  <p v-if="getEmergencyQuoteText(val)" class="manual-quote-line">
                                    <span class="manual-quote-label">需求内容：</span>
                                    <span class="manual-quote-value">{{
                                      getEmergencyQuoteText(val)
                                    }}</span>
                                  </p>
                                </div>
                              </div>
                              <p v-if="getManualReplyText(val)" class="manual-reply-text"
                                v-html="getManualReplyText(val).replace(/\n/g, '<br>')"></p>
                            </div>
                          </article>
                          <article v-else class="result-card" :key="'success-' + index">
                            <div class="card-main">
                              <div class="card-head">
                                <div class="card-head-left">
                                  <div class="badge-row">
                                    <span class="badge status-success">处理完成</span>
                                    <span class="badge" v-if="val.demand_code">{{
                                      getDemandCodeLabel(val.demand_code)
                                    }}</span>
                                  </div>
                                  <time class="card-time" v-if="val.complete_time">{{
                                    val.complete_time
                                  }}</time>
                                </div>
                                <button
                                  type="button"
                                  class="card-toggle"
                                  v-if="hasResultCardMeta(val)"
                                  @click="toggleResultCard(val)"
                                >
                                  {{ isResultCardOpen(val) ? "收起" : "展开" }}
                                  <i :class="isResultCardOpen(val)
                                    ? 'el-icon-arrow-up'
                                    : 'el-icon-arrow-down'
                                    "></i>
                                </button>
                              </div>
                              <div class="card-con">
                                <div class="card-body">
                                  <p class="card-title">{{ val.original }}</p>
                                  <p class="card-desc">{{ val.content || val.original }}</p>
                                </div>

                                <div
                                  class="card-meta"
                                  v-if="hasResultCardMeta(val)"
                                  v-show="isResultCardOpen(val)"
                                >
                                 <div class="card-meta-row" v-if="val.title">
                                    <span class="card-meta-label">标题</span>
                                    <span class="card-meta-value">{{ val.title }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.author">
                                    <span class="card-meta-label">{{ val.demand_code == 'patent' ? '发明人' : '作者' }}</span>
                                    <span class="card-meta-value">{{ val.author }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.journal_name">
                                    <span class="card-meta-label">期刊</span>
                                    <span class="card-meta-value">{{ val.journal_name }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.year">
                                    <span class="card-meta-label">{{ val.demand_code == 'standard' ? '日期' : '年份' }}</span>
                                    <span class="card-meta-value">{{ val.year }}</span>
                                  </div>
                                  <!-- <div class="card-meta-row" v-if="val.publisher">
                                    <span class="card-meta-label">出版社</span>
                                    <span class="card-meta-value">{{ val.publisher }}</span>
                                  </div> -->
                                  <div class="card-meta-row" v-if="val.doi">
                                    <span class="card-meta-label">DOI</span>
                                    <span class="card-meta-value">{{ val.doi }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.isbn">
                                    <span class="card-meta-label">{{ val.demand_code == 'standard' ? '标准号' : val.demand_code ==
                                      'patent'?'专利号':'ISBN'}}</span>
                                    <span class="card-meta-value">{{ val.isbn }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.standard_status">
                                    <span class="card-meta-label">标准状态</span>
                                    <span class="card-meta-value">{{ val.standard_status }}</span>
                                  </div>
                                  <!-- <div class="card-meta-row" v-if="val.demand_code">
                                    <span class="card-meta-label">需求类型</span>
                                    <span class="card-meta-value">{{
                                      getDemandCodeLabel(val.demand_code)
                                      }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.content">
                                    <span class="card-meta-label">识别内容</span>
                                    <span class="card-meta-value" v-html="val.content"></span>
                                  </div> -->
                                  <div class="card-meta-row" v-if="val.password">
                                    <span class="card-meta-label">链接密码</span>
                                    <span class="card-meta-value">{{ val.password }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card-note" v-if="val.leave_word" v-html="formatMultilineText(val.leave_word)"></div>
                            <div class="card-actions">
                              <div class="card-actions__start">
                                <el-dropdown class="card-action-dropdown card-action-dropdown--link" trigger="click"
                                  placement="bottom-start" popper-class="card-err-feedback-dropdown"
                                  @command="(reason) => handleErrFeedbackCommand(val, reason)">
                                  <button type="button" class="card-action card-action--link card-action--dropdown">
                                    错误反馈
                                    <i class="el-icon-arrow-down card-action-chevron"></i>
                                  </button>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="option in errFeedbackOptions" :key="option"
                                      :command="option">
                                      {{ option }}
                                    </el-dropdown-item>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>
                              <div class="card-actions__end">
                                <template v-if="canShowTranslationArea(val)">
                                  <button type="button"
                                    :class="['card-action', isCardEndActionAccent(val, 'translationSubmit') ? 'card-action--accent' : 'card-action--outline']"
                                    v-if="canShowTranslationSubmit(val)" @click="handleTranslationSubmit(val)">
                                    <span v-if="isTranslationSubmitting(val)">提交中</span>
                                    <span v-else>提交翻译</span>
                                    <i v-if="isTranslationSubmitting(val)" class="el-icon-loading"></i>
                                  </button>
                                  <button type="button"
                                    :class="['card-action', isCardEndActionAccent(val, 'translationPreview') ? 'card-action--accent' : 'card-action--outline']"
                                    v-if="canShowTranslationPreview(val)" @click="handleTranslationPreview(val)">
                                    在线实时翻译
                                  </button>
                                  <el-dropdown v-if="canShowTranslationResult(val)"
                                    class="card-action-dropdown card-action-dropdown--outline" trigger="click"
                                    @command="(cmd) => handleTranslationDownload(val, cmd)">
                                    <button type="button"
                                      :class="['card-action', 'card-action--dropdown', isCardEndActionAccent(val, 'translationResult') ? 'card-action--accent' : 'card-action--outline']">
                                      查看翻译结果
                                      <i class="el-icon-arrow-down card-action-chevron"></i>
                                    </button>
                                    <el-dropdown-menu slot="dropdown">
                                      <el-dropdown-item command="online">在线预览</el-dropdown-item>
                                      <el-dropdown-item command="translate:pdf">下载译文 PDF版</el-dropdown-item>
                                      <el-dropdown-item command="translate:word">下载译文 Word版</el-dropdown-item>
                                      <el-dropdown-item command="origin">下载原文</el-dropdown-item>
                                      <el-dropdown-item command="compare">下载对照版</el-dropdown-item>
                                    </el-dropdown-menu>
                                  </el-dropdown>
                                </template>
                                <button type="button"
                                  :class="['card-action', isCardEndActionAccent(val, 'similar') ? 'card-action--accent' : 'card-action--outline']"
                                  v-if="canShowSimilarAction(val)" @click="handleSimilarAction(val)">
                                  {{ getSimilarActionLabel(val) }}
                                </button>
                                <button type="button"
                                  :class="['card-action', isCardEndActionAccent(val, 'link') ? 'card-action--accent' : 'card-action--outline']"
                                  v-if="val.short_link && val.short_link.length > 0"
                                  @click="openLink(val.short_link)">
                                  链接地址
                                </button>
                              </div>
                            </div>
                          </article>
                        </template>
                      </div>

                      <div class="result-card-list" v-if="item.message.fail && item.message.fail.length > 0">
                        <template v-for="(val, index) in item.message.fail">
                          <article v-if="isEmergencyMessage(val)" class="manual-reply-card"
                            :key="'manual-fail-' + index">
                            <span v-if="isManualAssistantReply(val)" class="manual-reply-badge">人工助手回复</span>
                            <span v-else class="manual-reply-badge manual-reply-badge--consultant">图书馆参考咨询员</span>
                            <div class="manual-reply-panel">
                              <div class="manual-quote-source">
                                <span class="quote-source-bar" aria-hidden="true"></span>
                                <div class="manual-quote-content">
                                  <p v-if="val.demand_code" class="manual-quote-line">
                                    <span class="manual-quote-label">需求类型：</span>
                                    <span class="manual-quote-value">{{
                                      getDemandCodeLabel(val.demand_code)
                                    }}</span>
                                  </p>
                                  <p v-if="getEmergencyQuoteText(val)" class="manual-quote-line">
                                    <span class="manual-quote-label">需求内容：</span>
                                    <span class="manual-quote-value">{{
                                      getEmergencyQuoteText(val)
                                    }}</span>
                                  </p>
                                </div>
                              </div>
                              <p v-if="getManualReplyText(val)" class="manual-reply-text"
                                v-html="getManualReplyText(val).replace(/\n/g, '<br>')"></p>
                            </div>
                          </article>
                          <article v-else class="result-card" :key="'fail-' + index">
                            <div class="card-main">
                              <div class="card-head">
                                <div class="card-head-left">
                                  <div class="badge-row">
                                    <span class="badge" :class="getFailStatusClass(val)">{{ getFailStatusLabel(val)
                                    }}</span>
                                    <span class="badge" v-if="val.demand_code">{{
                                      getDemandCodeLabel(val.demand_code)
                                    }}</span>
                                  </div>
                                  <time class="card-time" v-if="val.complete_time">{{
                                    val.complete_time
                                  }}</time>
                                </div>
                                <button
                                  type="button"
                                  class="card-toggle"
                                  v-if="hasResultCardMeta(val)"
                                  @click="toggleResultCard(val)"
                                >
                                  {{ isResultCardOpen(val) ? "收起" : "展开" }}
                                  <i :class="isResultCardOpen(val)
                                    ? 'el-icon-arrow-up'
                                    : 'el-icon-arrow-down'
                                    "></i>
                                </button>
                              </div>
                              <div class="card-con">
                                <div class="card-body">
                                  <p class="card-title">{{ val.original }}</p>
                                  <p class="card-desc">{{ val.content || val.original }}</p>
                                </div>
                                <div
                                  class="card-meta"
                                  v-if="hasResultCardMeta(val)"
                                  v-show="isResultCardOpen(val)"
                                >

                                <div class="card-meta-row" v-if="val.title">
                                    <span class="card-meta-label">标题</span>
                                    <span class="card-meta-value">{{ val.title }}</span>
                                  </div>
                                <div class="card-meta-row" v-if="val.author">
                                    <span class="card-meta-label">{{ val.demand_code == 'patent' ? '发明人' : '作者' }}</span>
                                    <span class="card-meta-value">{{ val.author }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.journal_name">
                                    <span class="card-meta-label">期刊</span>
                                    <span class="card-meta-value">{{ val.journal_name }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.year">
                                    <span class="card-meta-label">{{ val.demand_code == 'standard' ? '日期' : '年份' }}</span>
                                    <span class="card-meta-value">{{ val.year }}</span>
                                  </div>
                                  <!-- <div class="card-meta-row" v-if="val.publisher">
                                    <span class="card-meta-label">出版社</span>
                                    <span class="card-meta-value">{{ val.publisher }}</span>
                                  </div> -->
                                  <div class="card-meta-row" v-if="val.doi">
                                    <span class="card-meta-label">DOI</span>
                                    <span class="card-meta-value">{{ val.doi }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.isbn">
                                    <span class="card-meta-label">{{ val.demand_code == 'standard' ? '标准号' : val.demand_code ==
                                      'patent'?'专利号':'ISBN'}}</span>
                                    <span class="card-meta-value">{{ val.isbn }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.standard_status">
                                    <span class="card-meta-label">标准状态</span>
                                    <span class="card-meta-value">{{ val.standard_status }}</span>
                                  </div>
                                  <!-- <div class="card-meta-row" v-if="val.demand_code">
                                    <span class="card-meta-label">需求类型</span>
                                    <span class="card-meta-value">{{
                                      getDemandCodeLabel(val.demand_code)
                                    }}</span>
                                  </div>
                                  <div class="card-meta-row" v-if="val.content">
                                    <span class="card-meta-label">识别内容</span>
                                    <span class="card-meta-value" v-html="val.content"></span>
                                  </div> -->
                                  <div class="card-meta-row" v-if="val.password">
                                    <span class="card-meta-label">链接密码</span>
                                    <span class="card-meta-value">{{ val.password }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card-alert" v-if="val.fail_reason" v-html="formatMultilineText(val.fail_reason)"></div>
                            <div class="card-note" v-if="val.leave_word" v-html="formatMultilineText(val.leave_word)"></div>
                            <div class="card-actions card-actions--end-only"
                              v-if="canShowSimilarAction(val) || val.status == 7">
                              <div class="card-actions__end">
                                <button type="button"
                                  :class="['card-action', isCardEndActionAccent(val, 'similar', 'fail') ? 'card-action--accent' : 'card-action--outline']"
                                  v-if="canShowSimilarAction(val)" @click="handleSimilarAction(val)">
                                  {{ getSimilarActionLabel(val) }}
                                </button>
                                <button type="button"
                                  :class="['card-action', isCardEndActionAccent(val, 'feedbackLink', 'fail') ? 'card-action--accent' : 'card-action--outline']"
                                  v-if="val.status == 7" @click="openFeedbackStatus7(val)">
                                  补充来源链接
                                </button>
                              </div>
                            </div>
                          </article>
                        </template>
                      </div>

                      <div class="plain-message-block" v-if="
                        item.message.success.length == 0 &&
                        item.message.fail.length == 0 &&
                        item.message.processing.length == 0 &&
                        !item.message.quote.task_id
                      ">
                        <div class="analysis-result">
                          <p class="result-note plain-message-text" v-html="item.message.text.replace(/\n/g, '<br>')">
                          </p>
                          <div class="force-submit-tip" v-if="
                            item.message.text ===
                            '系统判断您的内容 【可能不是文献需求】，因此暂未处理。'
                          ">
                            <span class="force-submit-label">如果消息被误判：</span>
                            <button type="button" class="force-submit-action" @click="forceSubmintHandle(item)">
                              &gt;&gt;点击此处&lt;&lt;
                            </button>
                            <span class="force-submit-suffix">强行提交文献需求</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-else class="msg_txt_css" :class="{ 'msg-bubble--user': item.types == 1 }">
                      <template v-if="item.message.quote && item.message.quote.task_id">
                        <div class="quote-reply-block quote-reply-block--user">
                          <div class="quote-source quote-source--user-nested">
                            <span class="quote-source-bar" aria-hidden="true"></span>
                            <div class="quote-source-body">
                              <p class="quote-source-line" v-if="item.message.quote.demand_code">
                                <span class="quote-source-label">需求类型：</span>
                                <span class="quote-source-value">{{
                                  getDemandCodeLabel(item.message.quote.demand_code)
                                }}</span>
                              </p>
                              <p class="quote-source-line" v-if="item.message.quote.content">
                                <span class="quote-source-label">需求内容：</span>
                                <span class="quote-source-value">{{
                                  item.message.quote.content
                                }}</span>
                              </p>
                            </div>
                          </div>
                          <p v-if="item.message.text" class="user-message-text"
                            v-html="item.message.text.replace(/\n/g, '<br>')"></p>
                        </div>
                      </template>

                      <div v-else class="plain-msg-text" v-html="item.message.text.replace(/\n/g, '<br>')"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="submit_or && cue_text_copy" class="message_li_css" style="justify-content: flex-end">
                <div class="msg_txt_">
                  <div class="msg_txt_css" style="padding: 12px;background: #F4F4F4; white-space: pre-wrap">
                    <span>{{ cue_text_copy }}</span>
                  </div>
                </div>
              </div>

              <div v-if="submit_or_copy" class="message_li_css conversation-item is-processing">
                <div class="msg_txt_" style="width: calc(100% - 50px)">
                  <div class="ai-reply-header">
                    <span class="ai-reply-badge">AI助手回复</span>
                  </div>
                  <div class="processing-block">
                    <template v-if="isProcessingLoading">
                      <div class="processing-row">
                        <span class="processing-text">
                          正在处理中<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
                        </span>
                      </div>
                      <template v-if="processingHintVisible">
                        <div class="processing-divider" aria-hidden="true"></div>
                        <p class="processing-hint">已收到您的需求，正在解析中，请稍等~</p>
                      </template>
                    </template>
                    <div v-else class="processing-row">
                      <span>{{ cue_text }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="up_css" :class="{ 'is-active': up_loading }" v-loading="up_loading"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0)"></div></div>
            </div>
          </div>
        </div>
        <div class="composer-footer">
          <div class="input_css">
            <div class="cite_input_css" style="padding: 10px 0 0 0" v-if="cite_data_copy.task_id">
              <div class="cite_css">
                <i class="el-icon-close cite_icon" @click="close_icon"></i>
                <div class="wenxian_li_s quotbox">
                  <div class="wenxian_li wenxian_txt_css" style="color: rgb(181 181 181); line-height: 15px !important">
                    <span class="wenxian_txt_css"><span class="li_tit" style="color: #bcbec2">需求类型：</span>
                      {{ cite_data_copy.demand_code }}
                    </span>
                  </div>
                  <div class="wenxian_li" style="color: rgb(181 181 181); line-height: 15px !important">
                    <span class="wenxian_txt_css"><span class="li_tit" style="color: #bcbec2">需求内容：</span>
                      {{ cite_data_copy.content }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="composer-band" :class="{
              'is-expanded': composerExpanded && !composerFullscreen,
              'is-fullscreen': composerFullscreen,
            }">
              <div class="composer" :class="{
                expanded: composerExpanded && !composerFullscreen,
                'is-fullscreen': composerFullscreen,
                'has-value': !!textarea_txt.trim(),
              }" @click="onComposerClick">
                <button
                  v-if="composerFocused || composerFullscreen || !!textarea_txt.trim()"
                  type="button"
                  class="composer-expand-btn"
                  :aria-label="composerFullscreen ? '收起' : '展开'"
                  @mousedown.prevent
                  @click.stop="toggleComposerFullscreen"
                >
                  <svg
                    v-if="!composerFullscreen"
                    class="composer-expand-icon is-collapse"
                    aria-hidden="true"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13 2V5.5M13 2H9.5" />
                    <path d="M3 14V10.5M3 14H6.5" />
                  </svg>
                  <svg
                    v-else
                    class="composer-expand-icon"
                    aria-hidden="true"
                    viewBox="0 0 16 16"
                  >
                    <path d="M9.5 5.5H13M9.5 5.5V2" />
                    <path d="M6.5 10.5H3M6.5 10.5V13" />
                  </svg>
                </button>
                <div class="compact-prompt" @click.stop="expandComposer">
                  <span>输入文献标题、DOI、ISBN、PMID、专利号或链接即可查询。支持批量输入，每行一条。</span>
                </div>
                <label class="composer-label" for="composer-query">
                  输入文献标题、DOI、ISBN、PMID、专利号或链接即可查询。支持批量输入，每行一条。
                  <span>示例：• 文献标题：城市交通拥堵治理...</span>
                  <span>　　　• DOI： 10.31486/toj.20.0025</span>
                  <span>　　　• PMID： 34239371</span>
                  <span>　　　• 专利号：CN107862857A</span>
                </label>
                <textarea id="composer-query" ref="textareaInput" v-model="textarea_txt" @input="onComposerInput"
                  @focus="expandComposer" @blur="onComposerBlur" @keydown="handleKeydown"></textarea>
                <div class="composer-actions">
                  <!-- <button type="button" class="example-btn" @click.stop="onExampleClick">
                    查看示例
                  </button> -->
                  <button type="button" class="ask-btn" aria-label="发送" @click.stop="lookup_sub">
                    <svg aria-hidden="true" viewBox="0 0 16 16">
                      <path d="M8 13V3" />
                      <path d="M4 7 8 3l4 4" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="retrieval_css" v-show="picked_id == 2">
      <RETRIEVAL ref="retrievalRef" @submitHandle="submitHandle"></RETRIEVAL>
    </div>
    <div class="history_search_css" v-if="history_or"></div>
    <van-dialog :value="show" :title="dialog_tit" show-cancel-button confirm-button-text="确定" cancel-button-text="取消"
      @confirm="onConfirm" @cancel="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="edit_ruleForm_css">
        <el-form-item label="需求类型" prop="code">
          <el-select v-model="ruleForm.code" size="medium" placeholder="请选择类型" popper-class="code_css"
            style="width: 70%">
            <el-option v-for="item in objectArray" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="需求内容" prop="text">
          <el-input type="textarea" v-model="ruleForm.text" :autosize="{ minRows: 3, maxRows: 5 }"
            placeholder="请填写需求内容..." style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="扩展信息" prop="supplement">
          <el-input type="textarea" v-model="ruleForm.supplement" :autosize="{ minRows: 3, maxRows: 5 }"
            placeholder="可添加扩展信息" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </van-dialog>
    <van-dialog :value="show_remark" title="添加备注" show-cancel-button confirm-button-text="确定" cancel-button-text="取消"
      @confirm="onConfirm_remark" @cancel="onCancel_remark">
      <div class="remark_box_css">
        <el-input type="textarea" v-model="remark_text" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="可添加您的备注"
          style="width: 100%"></el-input>
        <div class="remark_tag_s">
          <p style="
              line-height: 30px;
              font-size: 13px;
              color: #555;
              margin-top: 10px;
            ">
            常用备注
          </p>
          <el-tag size="medium" v-for="(item, index) in remark_tag_txt" :key="index"
            @click="remark_text = remark_text + item">{{ item }}</el-tag>
        </div>
      </div>
    </van-dialog>

    <el-dialog :visible.sync="dialogFeedback" width="480px" custom-class="source-link-dialog"
      @close="closeFeedbackDialog">
      <div slot="title" class="source-link-dialog-head">
        <div class="source-link-dialog-title">补充来源链接</div>
        <p class="source-link-dialog-hint">
          请粘贴以 http:// 或 https:// 开头的有效链接地址
        </p>
      </div>
      <el-form :model="feedbackForm" :rules="feedbackFormRules" ref="feedbackFormRef" class="source-link-dialog-form"
        @submit.native.prevent>
        <el-form-item prop="msg" class="source-link-dialog-field">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入"
            v-model="feedbackForm.msg"></el-input>
        </el-form-item>
        <div class="source-link-dialog-footer">
          <el-button class="source-link-dialog-btn source-link-dialog-btn--back" @click="dialogFeedback = false">
            返回
          </el-button>
          <el-button class="source-link-dialog-btn source-link-dialog-btn--confirm" type="primary"
            @click="submitFeedbackStatus7">
            确定
          </el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑反馈信息" :visible.sync="dialogErrFeedback" width="480px"
      custom-class="source-link-dialog source-link-dialog--plain" @close="closeErrFeedbackDialog">
      <el-form :model="errFeedbackForm" :rules="errFeedbackFormRules" ref="errFeedbackFormRef"
        class="source-link-dialog-form" @submit.native.prevent>
        <el-form-item prop="msg" class="source-link-dialog-field">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请描述您要反馈的问题"
            v-model="errFeedbackForm.msg"></el-input>
        </el-form-item>
        <div class="source-link-dialog-footer">
          <el-button class="source-link-dialog-btn source-link-dialog-btn--back" @click="dialogErrFeedback = false">
            返回
          </el-button>
          <el-button class="source-link-dialog-btn source-link-dialog-btn--confirm" type="primary"
            @click="submitErrFeedbackOther">
            确定
          </el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="dialogLinkUnreachable" width="560px"
      custom-class="source-link-dialog link-unreachable-dialog" @close="closeLinkUnreachableDialog">
      <div slot="title" class="source-link-dialog-head">
        <div class="source-link-dialog-title">针对"链接地址无法打开"的问题</div>
      </div>
      <div class="link-unreachable-dialog-body">
        <p class="link-unreachable-desc">
          我们将重新处理任务并更新下载链接，您可尝试使用新链接下载。相关文献也将发送至您的个人邮箱，请注意查收。若需修改邮箱，可前往青梨小程序「我的—管理与认证」进行设置。
        </p>
        <el-form :model="linkUnreachableForm" :rules="linkUnreachableFormRules" ref="linkUnreachableFormRef"
          class="source-link-dialog-form" @submit.native.prevent>
          <el-form-item v-if="linkUnreachableHasEmail" class="source-link-dialog-field">
            <el-input :value="linkUnreachableMaskedEmail" disabled></el-input>
          </el-form-item>
          <template v-else>
            <el-form-item prop="email" class="source-link-dialog-field link-unreachable-field">
              <el-input v-model="linkUnreachableForm.email" placeholder="请输入邮箱地址" clearable></el-input>
            </el-form-item>
            <el-form-item prop="email_code" class="source-link-dialog-field link-unreachable-field">
              <el-input v-model="linkUnreachableForm.email_code" placeholder="请输入验证码">
                <button type="button" slot="suffix" class="link-unreachable-send-code"
                  :disabled="linkUnreachableCodeCountdown > 0" @click="sendLinkUnreachableEmailCode">
                  {{
                    linkUnreachableCodeCountdown > 0
                      ? `${linkUnreachableCodeCountdown}s`
                      : "发送验证码"
                  }}
                </button>
              </el-input>
            </el-form-item>
          </template>
        </el-form>
        <div class="source-link-dialog-footer">
          <el-button class="source-link-dialog-btn source-link-dialog-btn--back" @click="dialogLinkUnreachable = false">
            返回
          </el-button>
          <el-button class="source-link-dialog-btn source-link-dialog-btn--confirm" type="primary"
            :loading="linkUnreachableSubmitting" @click="confirmLinkUnreachableFeedback">
            确定
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="相似推荐" :visible.sync="similarDialogVisible" width="600px" class="greater"
      custom-class="dialog_file_css recommend_css" :modal-append-to-body="true" @close="closeSimilarDialog">
      <div class="similar-recommend-body" v-loading="similarLoading" element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading">
        <div class="prompt_txt">
          <div class="prompt_txt_css">
            由AI根据当前资源智能匹配提供相关推荐，相似资源将视为一个新的需求查找该需求会消耗文献查询量。
          </div>
        </div>
        <div class="canto_css" v-if="similarList.length > 0">
          <div class="canto_li">
            <div class="canto_tit">【标题】</div>
            <div class="canto_con" :style="similarList[similarPage].isoa ? 'width: calc(100% - 215px);' : ''"
              v-html="similarList[similarPage].title"></div>
            <div class="isoa_css" v-if="similarList[similarPage].isoa">
              <img src="../../../assets/imgs/2.2/isoa.png" alt="" />
              <span class="isoa_txt">Open Access</span>
            </div>
          </div>
          <div class="canto_li" v-if="similarList[similarPage].isbn">
            <div class="canto_tit">【ISBN】</div>
            <div class="canto_con">{{ similarList[similarPage].isbn }}</div>
          </div>
          <div class="canto_li" v-if="similarList[similarPage].doi">
            <div class="canto_tit">【DOI】</div>
            <div class="canto_con">{{ similarList[similarPage].doi }}</div>
          </div>
          <div class="canto_li" v-if="similarList[similarPage].author && similarList[similarPage].author.length > 0">
            <div class="canto_tit">【作者】</div>
            <div class="canto_con">{{ similarList[similarPage].author.join(" ; ") }}</div>
          </div>
          <div class="canto_li" v-if="similarList[similarPage].year">
            <div class="canto_tit">【出版时间】</div>
            <div class="canto_con">{{ similarList[similarPage].year }}</div>
          </div>
          <div class="canto_li" v-if="similarList[similarPage].publisher">
            <div class="canto_tit">【出版地】</div>
            <div class="canto_con">{{ similarList[similarPage].publisher }}</div>
          </div>
          <div class="canto_li" v-if="similarList[similarPage].abstract">
            <div class="canto_tit">【内容摘要】</div>
            <div class="canto_con">
              <span v-if="!similarExpanded && similarList[similarPage].abstract.length > 120">
                {{ similarList[similarPage].abstract.slice(0, 120) }}...
              </span>
              <span v-else>{{ similarList[similarPage].abstract }}</span>
              <span class="toggle-btn" v-if="similarList[similarPage].abstract.length > 120"
                @click="similarExpanded = !similarExpanded">
                {{ similarExpanded ? "收起" : "展开" }}
              </span>
            </div>
          </div>
        </div>
        <div class="canto_handoff" v-if="similarList.length > 0">
          <div class="handoff_left" @click="prevSimilarPage"
            :style="similarPage == 0 ? 'color: var(----, #AAADB5);' : 'cursor: pointer;'">
            <i class="el-icon-arrow-left"></i>
            <span>上一篇</span>
          </div>
          <div class="handoff_con">{{ similarPage + 1 }} / {{ similarList.length }}</div>
          <div class="handoff_right" @click="nextSimilarPage"
            :style="similarPage + 1 == similarList.length ? 'color: var(----, #AAADB5);' : 'cursor: pointer;'">
            <span>下一篇</span><i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="submit_btn_css" v-if="similarList.length > 0" @click="submitSimilarDemand">
          <div class="submit_btn">
            {{ similarSubmitText }}
            <i v-if="similarSubmitText == '提交中'" class="el-icon-loading"></i>
          </div>
        </div>
        <div class="canto_none" v-if="similarList.length <= 0">
          <span v-if="!similarLoading">暂无资源</span>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="文档学术翻译" :visible.sync="dialogTranslation" width="580px" class="message"
      custom-class="dialog_file_css">
      <p style="color: var(---, #6b6e73); line-height: 24px">
        提交此篇文献至文档学术翻译任务？这将消耗您的文档翻译次数。任务处理完成后，您可以点击“查看结果“按钮查看翻译结果。
      </p>
      <p style="
          padding: 24px 24px 0px 24px;
          color: #e2426b;
          line-height: 24px;
          text-align: center;
        ">
        剩余翻译次数：{{ translationRemainderNumber }}次
      </p>
      <div style="padding: 24px; display: flex; justify-content: flex-end">
        <el-button style="
            color: var(---, #262729);
            background: var(---300, #f1f2f2);
            border: none !important;
          " class="dialog_btn" @click="dialogTranslation = false">取 消</el-button>
        <el-button style="
            color: var(--white-dark-white, #fff);
            background: #e2426b;
            border: none !important;
          " type="primary" class="dialog_btn" @click="confirmTranslationSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="链接地址" :visible.sync="dialogVisible" :width="dialogUrl.length > 1 ? '460px' : '460px'"
      @close="closeDialog" custom-class="dialog_file_css" :show-close="false">
      <div class="link_css">
        <div class="link_url_css" v-for="(item, index) in dialogUrl" :key="index">
          <div class="link_url">
            <span class="url_tit">{{
              dialogUrl.length > 1
                ? "链接" + numberToChinese(index + 1)
                : "链接"
            }}
              <span v-if="dialogUrl.length <= 1">&ensp;</span>
            </span>
            <span id="copy" class="inputText"><span class="urlText" style="" @click="openLink01(item)">{{
              item
            }}</span></span>
            <img @click="copyLink01(item)" style="cursor: pointer" src="../../../assets/imgs/2.2/copy.png" alt="" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="footer_btn" @click="closeDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import $ from "jquery";
import axios from "axios";
import RETRIEVAL from "./retrieval.vue";
import {
  Identify,
  submit,
  categoryList,
  messagerecordData,
  messageDetail,
  manual,
  errorFeedback,
  newDemandPost,
  newDemandCheck,
  getfileformat,
  newYiCaiTask_id,
} from "@/Api/manage";
import {
  personalMessage,
  emailRegister,
  userComplete,
  wenNumber,
} from "@/Api/userMessage";
import { getData, download_ql } from "@/Api/translation";
export default {
  inject: ["reloads"],
  data() {
    return {
      textarea_txt: "",
      composerExpanded: false,
      composerFullscreen: false,
      composerFocused: false,
      composerBlurLock: false,
      //   DOI:10.31486/toj.20.0025\nPMID:34239371\n

      tab_or: true,
      message: "",
      identifyList: [],
      downloadList: [],
      legalArr: [],
      array: [],
      show: false,
      dialog_tit: "编辑需求",
      objectArray: [],
      codeArray: [],
      ruleForm: {
        code: "",
        text: "",
        supplement: "",
      },
      edit_index: 0,
      rules: {
        code: [
          { required: true, message: "请选择需求类型", trigger: "change" },
        ],
        text: [{ required: true, message: "请填写需求内容", trigger: "blur" }],
        // supplement: [
        //   { required: true, message: "请填写扩展信息", trigger: "blur" },
        // ],
      },
      headers: {
        token: localStorage.getItem("token"),
      },
      download_num: 0,
      remark_text: "",
      show_remark: false,
      remark_tag_txt: ["正式版", "补充材料", "查收查引"],
      messageData: [],
      message_count: 0,
      messageQuery: {
        size: 10,
        new_data: "",
        search: "",
        last_id: "",
        direction: "up",
        old_year: "",
      },
      submit_or: false,
      submit_or_copy: false,
      processingHintVisible: false,
      processingHintTimer: null,
      cue: {
        type: 1,
        text: "",
        organ_code: "BJYKQXKJ001",
      },
      organ_code_copy: "",
      cue_text: "",
      startY: 0,
      isAtTop: true,
      isAtBottom: false,
      down_loading: false,
      down_text: "",
      up_loading: false,
      up_text: "",
      cue_text_copy: "",
      result_data: {},
      scrollHeight: 0,
      cite_data_copy: {},
      merge_ids: [],
      submitList_copy: [],
      fileList: [],
      shake_or: false,
      myDivStyle: {
        height: "100%",
        overflowX: "hidden",
        overflowY: "auto",
      },
      history_or: false,
      isReloadingMessages: false,
      picked_id: 1,
      intervalId: null,
      timer: "",
      dialogUrl: [],
      dialogVisible: false, // 链接地址
      ongoing: false,
      dialogFeedback: false,
      feedbackForm: {
        task_id: "",
        msg: "",
      },
      dialogErrFeedback: false,
      errFeedbackForm: {
        task_id: "",
        msg: "",
      },
      errFeedbackOptions: [
        "链接地址无法访问",
        "需要正式版",
        "需要补充材料",
        "内容不符",
        "其他",
      ],
      dialogLinkUnreachable: false,
      linkUnreachableHasEmail: false,
      linkUnreachableUserEmail: "",
      linkUnreachableSubmitting: false,
      linkUnreachableCodeCountdown: 0,
      linkUnreachableCodeTimer: null,
      linkUnreachableForm: {
        task_id: "",
        email: "",
        email_code: "",
      },
      codeType: {
        zhBook: { text: "中文书" },
        enBook: { text: "英文书" },
        PMID: { text: "PMID" },
        PMC: { text: "PMC" },
        DOI: { text: "DOI" },
        Url: { text: "链接地址" },
        zhDoc: { text: "中文文献" },
        enDoc: { text: "英文文献" },
        patent: { text: "专利" },
        standard: { text: "标准" },
        annex: { text: "附件" },
        negative: { text: "紧急消息" },
      },
      similarDialogVisible: false,
      similarLoading: false,
      similarList: [],
      similarPage: 0,
      similarExpanded: false,
      similarSubmitText: "提交查找",
      similarRowCopy: null,
      similarSubmitAjax: null,
      // --- 提交翻译 ---
      translationDemandMap: {},
      translationHistoryFileList: [],
      dialogTranslation: false,
      translationRemainderNumber: 0,
      translationRowCopy: null,
      translationSubmittingTaskId: "",
    };
  },
  computed: {
    feedbackFormRules() {
      return {
        msg: [
          {
            validator: (rule, value, callback) => {
              const err = this.validateFeedback7ForSubmit(value);
              if (!err) callback();
              else callback(new Error(err));
            },
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    errFeedbackFormRules() {
      return {
        msg: [
          { required: true, message: "请输入反馈消息", trigger: "blur" },
          { min: 5, message: "反馈信息内容至少5字符", trigger: "blur" },
        ],
      };
    },
    linkUnreachableMaskedEmail() {
      return this.maskUserEmail(this.linkUnreachableUserEmail);
    },
    linkUnreachableFormRules() {
      if (this.linkUnreachableHasEmail) {
        return {};
      }
      return {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入有效的邮箱地址", trigger: "blur" },
        ],
        email_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      };
    },
    isProcessingLoading() {
      return !this.cue_text || this.cue_text === "_";
    },
  },
  created() {
    // 首页跳转进入
    if (sessionStorage.getItem("mes")) {
      let mes = JSON.parse(sessionStorage.getItem("mes"));
      this.organ_code_copy = mes.org_code;
      this.cue.organ_code = mes.org_code;
    } else {
      this.getMessage();
    }
    let searchText = sessionStorage.getItem("searchText");
    if (searchText) {
      this.textarea_txt = searchText;
      this.composerExpanded = true;
      sessionStorage.removeItem("searchText");
      this.lookup_sub();
      return;
    }
    if (this.$route.query.token) {
      localStorage.setItem("token", this.$route.query.token);
      if (this.$route.query.data) {
        let text_val = this.$route.query.data.replace(/\|/g, "\n");
        let json_ = {
          text_val: text_val,
          or: this.$route.query.or,
        };
        window.sessionStorage.removeItem("id_data");
        window.sessionStorage.setItem("text_data", JSON.stringify(json_));
        let that = this;
        that.$router.replace(
          {
            path: "/qinli_app",
            query: {
              token: this.$route.query.token,
              reload: new Date().getTime(),
            },
          },
          () => {
            that.reloads(); //刷新页面
          }
        );
      } else if (this.$route.query.id || this.$route.query.date) {
        let json_ = {
          id: this.$route.query.id ? this.$route.query.id : "",
          date: this.$route.query.date ? this.$route.query.date : "",
        };
        window.sessionStorage.removeItem("text_data");
        window.sessionStorage.setItem("id_data", JSON.stringify(json_));
        let that = this;
        setTimeout(function () {
          that.$router.replace(
            {
              path: "/qinli_app",
              query: {
                token: that.$route.query.token,
                reload: new Date().getTime(),
              },
            },
            () => {
              that.reloads(); //刷新页面
            }
          );
        }, 500);
      } else {
        if (window.sessionStorage.getItem("text_data")) {
          let text_ = JSON.parse(window.sessionStorage.getItem("text_data"));
          if (text_.or == "true") {
            this.tab_or = false;
          } else {
            this.tab_or = true;
          }
          this.textarea_txt = text_.text_val;

          this.lookup_sub();
        } else if (window.sessionStorage.getItem("id_data")) {
          let id_data = JSON.parse(window.sessionStorage.getItem("id_data"));
          if (id_data.id) {
            this.messageQuery.last_id = id_data.id - 0 - 1;
          } else if (id_data.date) {
            this.messageQuery.new_data = id_data.date;
          }
          this.messageQuery.direction = "down";
          this.tab_or = true;
          this.get_messageRecord_history();
        }
      }
    } else {
      wx.miniProgram.navigateTo({
        url: "/pages/my/my", // 指定跳转至小程序页面的路径
        success: (res) => {
          console.log(res); // 页面跳转成功的回调函数
        },
        fail: (err) => {
          console.log(err); // 页面跳转失败的回调函数
        },
      });
    }
    this.get_data();
    this.dataRefreh();
  },
  mounted() {
    // 监听当前页面 显示状态
    window.addEventListener("visibilitychange", this.hanldeVisiblityChange);
    this.handleLayoutResize = () => {
      this.adjustDivHeight();
    };
    window.addEventListener("resize", this.handleLayoutResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.handleLayoutResize);
    }
    // 当页面被销毁时 移除监听
    this.$on("hook:beforeDestroy", () => {
      // console.info("ws 我被销毁了, 移除监听>>>");
      window.removeEventListener(
        "visibilitychange",
        this.hanldeVisiblityChange
      );
      window.removeEventListener("resize", this.handleLayoutResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          "resize",
          this.handleLayoutResize
        );
      }
    });
    if (this.tab_or && !window.sessionStorage.getItem("id_data")) {
      this.get_messageRecord();
    }
    this.fetchTranslationRemainderNumber();
    this.$nextTick(() => {
      if (!window.sessionStorage.getItem("id_data")) {
      }
    });
  },
  watch: {
    textarea_txt(val) {
      if (val && val.trim()) {
        this.composerExpanded = true;
      }
    },
    messageData() {
      this.$nextTick(() => {
        if (
          !this.messageQuery.last_id &&
          !window.sessionStorage.getItem("id_data")
        ) {
          // this.scrollToBottom();
        }
        //
      });
    },
    isProcessingLoading(val) {
      this.syncProcessingHint(val);
    },
    submit_or_copy(val) {
      if (!val) {
        this.resetProcessingHint();
      } else if (this.isProcessingLoading) {
        this.syncProcessingHint(true);
      }
    },
  },

  methods: {
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        // console.log("刷新" + new Date());
        this.flushedAutomatic(); //加载数据函数
      }, 5000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    hanldeVisiblityChange() {
      if (document.visibilityState === "hidden") {
        // console.log("ws  hidden>>>关闭定时器");
        this.clear();
      } else if (document.visibilityState === "visible") {
        // console.log("ws  visible>>>启动定时器");
        this.dataRefreh();
      }
    },
    getMessage() {
      if (localStorage.getItem("token")) {
        personalMessage()
          .then((res) => {
            if (res.data.data) {
              sessionStorage.setItem("mes", JSON.stringify(res.data.data));
              res.data.data;
              this.organ_code_copy = res.data.data.org_code;
              this.cue.organ_code = res.data.data.org_code;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    adjustDivHeight() {
      this.$nextTick(() => {
        if (!this.$refs.myDiv) return;
        this.myDivStyle = {
          height: "100%",
          overflowX: "hidden",
          overflowY: "auto",
        };
      });
    },
    expandComposer() {
      this.composerExpanded = true;
      this.composerFocused = true;
      this.$nextTick(() => {
        if (this.$refs.textareaInput) {
          this.$refs.textareaInput.focus();
        }
      });
    },
    toggleComposerFullscreen() {
      if (this.composerFullscreen) {
        this.composerBlurLock = true;
        this.exitComposerFullscreen();
        this.$nextTick(() => {
          if (this.$refs.textareaInput) {
            this.$refs.textareaInput.focus();
          }
          window.setTimeout(() => {
            this.composerBlurLock = false;
          }, 200);
        });
        return;
      }
      const layout = this.$el && this.$el.querySelector(".chat-layout");
      if (!layout) return;
      layout.style.setProperty("--composer-input-height", "300px");
      this.composerExpanded = true;
      this.composerFocused = true;
      this.composerFullscreen = true;
      this.$nextTick(() => {
        if (this.$refs.textareaInput) {
          this.$refs.textareaInput.focus();
        }
      });
    },
    exitComposerFullscreen() {
      if (!this.composerFullscreen) return;
      this.composerFullscreen = false;
      this.composerExpanded = true;
      this.composerFocused = true;
      this.$nextTick(() => {
        const layout = this.$el && this.$el.querySelector(".chat-layout");
        if (layout) {
          layout.style.removeProperty("--composer-input-height");
        }
      });
    },
    collapseComposerIfEmpty() {
      if (this.composerBlurLock || this.composerFullscreen) return;
      if (this.textarea_txt.trim()) return;
      this.composerExpanded = false;
    },
    onComposerClick() {
      if (!this.composerExpanded) {
        this.expandComposer();
      }
    },
    onComposerBlur() {
      window.setTimeout(() => {
        this.composerFocused = false;
        this.collapseComposerIfEmpty();
      }, 120);
    },
    onComposerInput() {
      if (this.textarea_txt.trim()) {
        this.composerExpanded = true;
      }
      this.adjustDivHeight();
    },
    onExampleClick(event) {
      event.preventDefault();
      this.expandComposer();
    },
    scrollToBottom() {
      const container = this.$refs.myDiv;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
    scrollToBottomAfterRender() {
      this.$nextTick(() => {
        this.scrollToBottom();
        setTimeout(() => {
          this.scrollToBottom();
        }, 300);
      });
    },
    tab_type() {
      this.tab_or = !this.tab_or;
      this.textarea_txt = "";
      this.exitComposerFullscreen();
      this.composerExpanded = false;
      if (this.tab_or) {
        this.messageQuery = {
          size: 10,
          new_data: "",
          search: "",
          last_id: "",
          direction: "up",
        };
        this.get_messageRecord();
      } else {
        this.identifyList = [];
      }
    },
    get_data() {
      categoryList()
        .then((res) => {
          if (res.data.error_code == 0) {
            let resData = res.data.data;
            let keys = Object.keys(resData);
            let arr = [];
            let objArr = [];

            keys.forEach((item) => {
              let obj = {};
              obj.code = item;
              obj.name = resData[item];
              obj.isFirst = false;
              objArr.push(obj);
              arr.push(resData[item]);
            });
            this.array = arr;

            this.objectArray = objArr;
            this.codeArray = keys;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    lookup_sub() {
      if (this.shake_or) {
        return;
      }
      if (!this.textarea_txt) {
        this.$message({
          message: "需求为空！",
          type: "warning",
        });
        return;
      } else if (this.textarea_txt.length > 2048) {
        // Toast.fail("需求为空！");
        this.$message({
          message: "输入内容不能超过2048字！",
          type: "warning",
        });
        return;
      }

      // this.clear(); // 清除定时器
      this.exitComposerFullscreen();
      this.submit_or_copy = true;
      if (!this.tab_or) {

        Identify({ text: this.textarea_txt })
          .then((res) => {
            if (res.data.error_code == 0) {
              this.dataRefreh(); //启动定时器
              let newArry = [];
              let downArry = [];
              let count = 0;

              res.data.data.forEach((item) => {
                for (let index = 0; index < item.result_list.length; index++) {
                  let obj = {};
                  obj.text = item.result_list[index].text;
                  obj.code = item.result_list[index].code;
                  obj.name = item.result_list[index].name;
                  obj.supplement = "";
                  if (item.result_list[index].code == "Other") {
                    obj.resultMsg = "请核对需求内容 ！";
                  } else {
                    obj.resultMsg = "";
                  }
                  obj.index = count;
                  obj.priority = "一般";
                  obj.remark = "";
                  obj.highlight = item.highlight;
                  // 单次提交限制10条需求
                  if (obj.code == "Other") {
                    obj.checked = false;
                    obj.disabled = false;
                  } else if (obj.code !== null && downArry.length < 10) {
                    downArry.push(obj);
                    obj.checked = true;
                    obj.disabled = false;
                  } else {
                    obj.checked = false;
                    obj.disabled = true;
                  }
                  newArry.push(obj);
                  count++;
                }
              });
              if (downArry.length == 10) {
                newArry.forEach((item, index) => {
                  if (item.checked == false) {
                    newArry[index].disabled = true;
                  }
                });
              }
              let legalArr = newArry.filter((item) => {
                return this.array.indexOf(item.name) > -1;
              });
              if (downArry.length == 10) {
                this.$message({
                  message: "单次最多提交10条！",
                  type: "warning",
                });
              }

              this.identifyList = newArry;
              this.downloadList = downArry;
              this.download_num = this.downloadList.length;
              this.legalArr = legalArr;
              this.toView = "identify";
              if (window.sessionStorage.getItem("text_data")) {
                window.sessionStorage.setItem("text_data", "");
              }

            } else {
              this.message = res.data.msg;
              this.$message({
                message: this.message,
                type: "warning",
              });
            }
            this.submit_or_copy = false
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        if (!this.cite_data_copy.id) {
          this.cue.quote_id = "";
        }
        this.cue.force_type = "";
        if (Object.keys(this.cite_data_copy).length > 0) {
          this.confirmErrFeedback(
            this.textarea_txt,
            this.cite_data_copy.task_id
          );
        } else {
          this.consultationAi();
        }
        if (window.sessionStorage.getItem("text_data")) {
          window.sessionStorage.setItem("text_data", "");
        }
      }
    },
    handleKeydown(event) {
      if (event.key === "Escape" && this.composerFullscreen) {
        event.preventDefault();
        this.toggleComposerFullscreen();
        return;
      }
      if (event.key === "Enter") {
        if (event.shiftKey) {
          // Shift + Enter：换行（默认行为，无需处理）
        } else {
          // Enter：提交内容
          event.preventDefault(); // 阻止默认的回车行为（如提交表单）
          this.lookup_sub();
        }
      }
    },
    consultationAi(type_) {
      if (this.shake_or) {
        return;
      } else {
        this.shake_or = true;
      }
      let that = this;
      that.cue_text = "";
      that.submit_or = true;
      that.submit_or_copy = true;
      if (that.textarea_txt) {
        that.cue.text = that.textarea_txt;
        that.cue_text_copy = that.textarea_txt;
      }

      let cue = {
        type: that.cue.type,
        text: that.cue.text,
        // quote_id: that.cue.quote_id ? that.cue.quote_id : null,
        organ_code: that.organ_code_copy,
        // force_type: that.cue.force_type ? that.cue.force_type : "",
        force_type: 2,
        type: 2,
        is_artificial: that.cue.is_artificial ? that.cue.is_artificial : 0,
        force_submint: type_ == "compulsion" ? true : false,
      };
      that.textarea_txt = "";
      that.composerExpanded = true;

      setTimeout(() => {
        that.scrollToBottom();
      }, 100);
      this.adjustDivHeight();
      that.returnMessageAjax = $.ajax({
        // url: "http://192.168.66.18:8007/api/user/consultation/",
        // url: "https://ql-test.newacademic.net/api/user/consultation/",
        url: process.env.VUE_APP_API_BASE_URL + "user/consultation/",
        // url: "https://xcx.newacademic.net/api/user/consultation/",
        data: JSON.stringify(cue),
        timeout: 50000, // 请求超时时间
        type: "Post",
        headers: {
          // "Content-Type": "application/json;charset=UTF-8",
          token: localStorage.getItem("token"),
        },
        // dataType: "json",
        processData: false, // 不处理数据
        contentType: false, // 不设置内容类型
        xhrFields: {
          onprogress: function (e) {
            that.cue_text = "_";
          },
          onload: function (e) {
            console.log(e);
          },
        },
        timeout: 1000 * 60 * 2,

        complete: function (XMLHttpRequest, status) {
          that.dataRefreh(); //启动定时器
          that.messageQuery.last_id = "";
          that.messageQuery.direction = "up";
          that.messageQuery.old_year = "";
          that.cue.quote_id = "";
          that.cue.is_artificial = "";
          that.cue.force_type = "";
          that.shake_or = false;
          if (XMLHttpRequest.responseJSON) {
            let responseJson = XMLHttpRequest.responseJSON;
            if (responseJson.error_code === 1) {
              that.$message({
                message: responseJson.msg,
                type: "warning",
              });
            }
          }

          that.reloadMessageList();
          if (Object.keys(that.cite_data_copy).length > 0) {
            that.manual_dispose(
              that.cite_data_copy.text.task_id,
              that.cue.text
            );
          }
        },
      });
    },
    manual_dispose(task_id, msg) {
      let anew_ = {
        task_id: task_id,
        source: 0,
        msg: msg,
      };

      manual(anew_)
        .then((res) => {
          if (res.data.error_code == 0) {
          }
          that.cite_data_copy = {};
        })
        .catch((err) => {
          that.cite_data_copy = {};
        });
    },
    clear_result() {
      this.identifyList = [];
    },
    edit_demand(row, i) {
      this.edit_index = i;
      this.ruleForm = {
        code: row.code,
        text: row.text,
        supplement: row.supplement,
      };
      this.dialog_tit = "编辑需求";
      this.show = true;
    },
    merge_demand() {
      this.submitList_copy = [];
      this.merge_ids = [];
      this.identifyList.forEach((item, index) => {
        if (item.checked) {
          this.submitList_copy.push(item);
          this.merge_ids.push(index);
        }
      });
      if (this.submitList_copy.length <= 1) {
        // Toast.fail("请至少选中两项");
        this.$message({
          message: "请至少选中两项",
          type: "warning",
        });
      } else {
        this.ruleForm = {
          code: this.submitList_copy[0].code,
          text: this.submitList_copy.map((item) => item.text).join(""),
          supplement: this.submitList_copy
            .map((item) => item.supplement)
            .join("\n"),
        };
        this.dialog_tit = "需求合并";
        this.show = true;
      }
    },

    remarkEdit(row, i) {
      this.edit_index = i;
      this.remark_text = row.remark;
      this.show_remark = true;
    },
    onCancel_remark() {
      this.show_remark = false;
    },
    onConfirm_remark() {
      this.identifyList[this.edit_index].remark = this.remark_text;
      this.show_remark = false;
    },
    checked_change(i) {
      if (this.identifyList[i].checked) {
        this.download_num = this.download_num + 1;
      } else {
        this.download_num = this.download_num - 1;
      }
      if (this.download_num >= 10) {
        this.identifyList.forEach((item, index) => {
          if (!item.checked) {
            item.disabled = true;
          }
        });
      } else {
        this.identifyList.forEach((item, index) => {
          item.disabled = false;
        });
      }
    },
    onConfirm() {
      if (this.dialog_tit == "编辑需求") {
        this.identifyList[this.edit_index].code = this.ruleForm.code;
        this.identifyList[this.edit_index].text = this.ruleForm.text;
        this.identifyList[this.edit_index].supplement =
          this.ruleForm.supplement;
        //   if (this.identifyList[this.edit_index].checked) {
        //     this.downloadList[this.edit_index].code = this.ruleForm.code;
        //     this.downloadList[this.edit_index].text = this.ruleForm.text;
        //     this.downloadList[this.edit_index].supplement =
        //       this.ruleForm.supplement;
        //   }

        this.objectArray.forEach((item, index) => {
          if (item.code == this.ruleForm.code) {
            this.identifyList[this.edit_index].name = item.name;
            //   if (this.identifyList[this.edit_index].checked) {
            //     this.downloadList[this.edit_index].name = item.name;
            //   }
          }
        });
        this.show = false;
      } else {
        Dialog.confirm({
          message: "确定合并？",
        })
          .then(() => {
            // this.identifyList.splice(i, 1);
            const filteredArray = this.identifyList.filter(
              (item, index) => !this.merge_ids.includes(index)
            );
            this.identifyList = filteredArray;
            let new_merge = {
              code: this.ruleForm.code,
              text: this.ruleForm.text,
              supplement: this.ruleForm.supplement,
              priority: this.submitList_copy[0].priority,
              name: this.submitList_copy[0].name,
              remark: this.submitList_copy
                .map((item) => item.remark)
                .join("\n"),
              checked: false,
              disabled: false,
              resultMsg: "",
            };
            this.identifyList.push(new_merge);
            this.show = false;
          })
          .catch(() => {
            // on cancel
            this.show = false;
          });
      }
    },
    onCancel() {
      this.show = false;
    },
    del_demand(row, i) {
      Dialog.confirm({
        message: "确定删除吗？",
      })
        .then(() => {
          this.identifyList.splice(i, 1);
        })
        .catch(() => {
          // on cancel
        });
    },
    handleSelect() {
      if (this.download_num > 0) {
        let submitList = [];
        this.identifyList.forEach((item, index) => {
          if (item.checked) {
            if (item.code == null || item.code == "null") {
              this.identifyList[index].resultMsg = " ✘ 需求类型错误";
            } else {
              submitList.push({
                id: index,
                type_code: item.code,
                text: item.text, // 需求内容
                supplement: item.supplement,
                original_text: "<b>" + item.text + "</b>", // 高亮文本
                priority: item.priority, //优先、一般
                remark: item.remark, // 备注信息
              });
            }
          }
        });

        let sub = {
          demand: submitList,
          text: this.textarea_txt,
        };
        submit(sub)
          .then((res) => {
            if (res.data.error_code == 0) {
              let sub_data = res.data.data;
              for (var key in sub_data) {
                let i = submitList[key].id;
                if (sub_data[key].code == 0) {
                  // 提交成功
                  this.identifyList[i].resultMsg = " ✔ 提交成功";
                } else {
                  // 提交失败
                  if (sub_data[key].msg == "今日您中文书的提交数量已达上限") {
                    this.identifyList[i].resultMsg = " ✘ 今日中文书达上限";
                  } else if (
                    sub_data[key].msg == "今日您非中文书的提交数量已达上限"
                  ) {
                    // 达上限时
                    this.identifyList[i].resultMsg = " ✘ 今日已达上限";
                  } else if (sub_data[key].msg == "今日已提交过此需求") {
                    // 重复提交时
                    this.identifyList[i].resultMsg = " ✘ 重复提交";
                  } else if (
                    sub_data[key].msg == "未知原因提交失败" ||
                    sub_data[key].msg == "需求提交过快"
                  ) {
                    // 提交失败时
                    this.identifyList[i].resultMsg = " ✘ 提交失败";
                  } else {
                    this.identifyList[i].resultMsg = " ！" + sub_data[key].msg;
                  }
                }
                this.identifyList[i].disabled = true;
                this.identifyList[i].checked = false;
              }
              let exists = Object.values(sub_data).some(
                (item) => item.code === 0
              );
              if (exists) {
                this.messageQuery = {
                  size: 10,
                  new_data: "",
                  search: "",
                  last_id: "",
                  direction: "up",
                };
                this.textarea_txt = "";
                this.tab_or = !this.tab_or;
                this.get_messageRecord();
              }
            }
          })
          .catch((err) => { });
      } else {
        this.$message({
          message: "需求为空",
          type: "warning",
        });
      }
    },
    priority_edit(i) {
      if (this.identifyList[i].priority == "优先") {
        this.identifyList[i].priority = "一般";
      } else {
        this.identifyList[i].priority = "优先";
      }
    },
    get_messageRecord_history() {
      this.messageQuery.type = 2;
      messagerecordData(this.messageQuery)
        .then((res) => {
          if (res.data.error_code == 0) {
            res.data.data.data.forEach((item, index) => {
              item.message = JSON.parse(item.message);
            });
            this.messageData = res.data.data.data;
            this.message_count = res.data.data.count;
            this.syncTranslationDemandStates(this.messageData);
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reloadMessageList() {
      this.isReloadingMessages = true;
      this.messageQuery = {
        size: 10,
        new_data: "",
        search: "",
        last_id: "",
        direction: "up",
        old_year: "",
        type: 2,
      };
      this.up_text = "";
      this.down_text = "";
      this.ongoing = true;
      return messagerecordData({ ...this.messageQuery })
        .then((res) => {
          if (res.data.error_code == 0) {
            this.messageData = this.sortMessageRecords(
              res.data.data.data.map((item) => this.parseMessageRecordItem(item))
            );
            this.message_count = res.data.data.count;
            this.syncTranslationDemandStates(this.messageData);
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.ongoing = false;
          this.isReloadingMessages = false;
          this.submit_or_copy = false;
          this.submit_or = false;
          this.cue_text_copy = "";
          this.cue_text = "";
        });
    },
    parseMessageRecordItem(item) {
      const record = { ...item };
      if (typeof record.message === "string") {
        record.message = JSON.parse(record.message);
      }
      const msg = record.message || {};
      if (!Array.isArray(msg.success)) msg.success = [];
      if (!Array.isArray(msg.fail)) msg.fail = [];
      if (!Array.isArray(msg.processing)) msg.processing = [];
      record.message = msg;
      return record;
    },
    sortMessageRecords(list) {
      return [...list].sort((a, b) => Number(a.id) - Number(b.id));
    },
    getForceSubmitUserText(aiItem) {
      const index = this.messageData.findIndex((m) => m.id === aiItem.id);
      if (index > 0) {
        for (let i = index - 1; i >= 0; i--) {
          const msg = this.messageData[i];
          if (msg.types == 1 && msg.message && msg.message.text) {
            return msg.message.text;
          }
        }
      }
      if (aiItem.message && Array.isArray(aiItem.message.demand) && aiItem.message.demand.length) {
        return aiItem.message.demand
          .map((d) => d.text || d.content || "")
          .filter(Boolean)
          .join("\n");
      }
      return "";
    },
    get_messageRecord() {
      if (this.isReloadingMessages) {
        return;
      }
      const container = this.$refs.myDiv;
      let prevScrollHeight = 0; // 获取添加新内容前的滚动高度
      let prevScrollTop = 0;
      if (container) {
        if (container.scrollHeight) {
          prevScrollHeight = container.scrollHeight;
        }
        // 获取添加新内容前的滚动高度
        if (container.scrollTop) {
          prevScrollTop = container.scrollTop;
        }
      }
      this.messageQuery.type = 2;
      this.ongoing = true;
      console.log("this.messageQuery.direction", this.messageQuery.direction);
      messagerecordData(this.messageQuery)
        .then((res) => {
          if (res.data.error_code == 0) {
            const fetchedList = res.data.data.data.map((item) =>
              this.parseMessageRecordItem(item)
            );
            // console.log(this.messageQuery.old_year)
            if (this.messageQuery.last_id || this.messageQuery.old_year) {
              if (this.messageQuery.direction == "down") {
                // console.log("bbbbbbbbb", this.messageQuery.direction);
                this.messageData = this.sortMessageRecords([
                  ...this.messageData,
                  ...fetchedList,
                ]);
              } else if (this.messageQuery.direction == "up") {
                // console.log("cccccc", this.messageQuery.direction);
                this.messageData = this.sortMessageRecords([
                  ...fetchedList,
                  ...this.messageData,
                ]);
              }
            } else {
              this.messageData = this.sortMessageRecords(fetchedList);
              this.$nextTick(() => {
                this.scrollToBottom();
              });
            }
            this.$nextTick(() => {
              if (this.messageQuery.direction == "up") {
                // 计算新高度
                const newScrollHeight = container.scrollHeight;
                const heightDifference = newScrollHeight - prevScrollHeight;
                // 调整滚动位置
                container.scrollTop = prevScrollTop + heightDifference;
              }
              if (this.messageQuery.direction) {
                if (res.data.data.data.length == 0) {
                  if (this.messageQuery.direction == "down") {
                    this.down_text = "已到底部";
                    // Toast("当前为最新记录");
                  } else if (this.messageQuery.direction == "up") {
                    if (this.messageQuery.old_year) {
                      this.up_text = "已到顶部";
                    } else {
                      const lastYear = new Date().getFullYear() - 1;
                      this.messageQuery.old_year = lastYear;
                      this.messageQuery.last_id = "";
                      // console.log("aa");
                      this.get_messageRecord();
                    }
                  }
                } else {
                  if (this.messageQuery.direction == "down") {
                    this.down_text = "";
                  } else if (this.messageQuery.direction == "up") {
                    this.up_text = "";
                  }
                  if (
                    this.messageData.length > 0 &&
                    this.messageData.length < 10 &&
                    !this.messageQuery.old_year
                  ) {
                    const lastYear = new Date().getFullYear() - 1;
                    this.messageQuery.old_year = lastYear;
                    this.messageQuery.last_id = "";
                    this.messageQuery.direction = "up";
                    // console.log(
                    //   "this.messageQuery.direction",
                    //   this.messageQuery.direction
                    // );
                    this.get_messageRecord();
                  }
                }
              }
              this.message_count = res.data.data.count;
              this.syncTranslationDemandStates(this.messageData);
              this.submit_or = false;
              this.up_loading = false;
              this.down_loading = false;
            });
          }
          if (window.sessionStorage.getItem("id_data")) {
            window.sessionStorage.setItem("id_data", "");
          }
          if (
            this.messageQuery.last_id ||
            this.messageQuery.new_data ||
            this.messageQuery.old_year
          ) {
            this.messageQuery.last_id = "";
            this.messageQuery.new_data = "";
          } else {
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
          this.$nextTick(() => {
            this.ongoing = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.ongoing = false;
        });
    },
    firstIndex_s(date) {
      return this.messageData.findIndex((item) => item.date_time === date);
    },
    goHistory() {
      this.history_or = !this.history_or;
    },
    backCourse() {
      wx.miniProgram.navigateTo({
        url: "/pages/course/course",
        // 指定跳转至小程序页面的路径
        success: (res) => {
          console.log(res); // 页面跳转成功的回调函数
        },
        fail: (err) => {
          console.log(err); // 页面跳转失败的回调函数
        },
      });
    },
    showExample() {
      this.textarea_txt = `DOI:10.31486/toj.20.0025\nPMID:34239371\nISBN:9782954099477`;
    },
    onTouchStart(event) {
      const touch = event.touches[0];
      this.startY = touch.clientY;
    },
    onTouchEnd(event) {
      const touch = event.changedTouches[0];
      const endY = touch.clientY;
      const div = this.$refs.myDiv;
      const scrollTop = div.scrollTop;
      const scrollHeight = div.scrollHeight;
      const clientHeight = div.clientHeight;
      this.isAtTop = scrollTop === 0;
      this.isAtBottom = scrollTop + clientHeight === scrollHeight;
      if (this.startY > endY + 30 && this.isAtBottom) {
        // 上拉动作
        console.log("Swiped up");
        this.handleSwipeUp();
      } else if (this.startY < endY - 30 && this.isAtTop) {
        // 下拉动作
        console.log("Swiped down");
        this.handleSwipeDown();
      }
    },
    handleSwipeUp() {
      // 处理上拉动作
      if (!this.down_text && !this.messageQuery.old_year) {
        this.up_loading = true;
        this.messageQuery.last_id =
          this.messageData[this.messageData.length - 1].id;
        this.messageQuery.direction = "down";
        this.get_messageRecord();
      }
    },
    handleSwipeDown() {
      // 处理下拉动作
      const container = this.$refs.myDiv;
      let prevScrollHeight = 0;
      if (container) {
        prevScrollHeight = container.scrollHeight;
        this.scrollHeight = container.scrollHeight;
      }
      if (!this.up_text) {
        this.down_loading = true;
        this.messageQuery.last_id = this.messageData[0].id;
        this.messageQuery.direction = "up";
        this.get_messageRecord();
      }
    },
    onScroll(event) {
      if (this.isReloadingMessages || this.ongoing) {
        return;
      }
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop === 0) {
        this.handleSwipeDown();
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        this.handleSwipeUp();
      }
    },
    openLink(short_link) {
      if (short_link.length === 1) {
        const url = short_link[0];
        const copyThenTipAndOpen = async () => {
          let copied = false;
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(url);
              copied = true;
            } else {
              const ta = document.createElement("textarea");
              ta.value = url;
              ta.setAttribute("readonly", "readonly");
              ta.style.position = "fixed";
              ta.style.left = "-9999px";
              document.body.appendChild(ta);
              ta.select();
              copied = document.execCommand("copy");
              document.body.removeChild(ta);
            }
          } catch (e) {
            copied = false;
          }
          this.$message({
            message: copied
              ? "复制成功，正在打开"
              : "复制失败，3秒后仍将尝试打开链接",
            type: copied ? "success" : "warning",
          });
          setTimeout(() => {
            window.open(url, "_blank");
          }, 1500);
        };
        copyThenTipAndOpen();
      } else {
        this.dialogUrl = short_link;
        this.dialogVisible = true;
      }
    },
    // 打开相似图书
    openSimilar(val) {
      this.handleSimilarAction(val);
    },
    canShowSimilarAction(val) {
      if (!val || val.isefficacy) return false;
      if (val.demand_code === "zhBook") {
        return !!val.similar_url;
      }
      const hasShortLink = val.short_link && val.short_link.length > 0;
      return (
        val.status === 3 ||
        (val.status === 4 && hasShortLink) ||
        val.status === 5
      );
    },
    getSimilarActionLabel(val) {
      if (!val) return "查找相似";
      if (val.demand_code === "zhBook") {
        if (val.result_info && val.result_info.TaoShuId) return "相关图书";
        if (val.TaoShuId) return "相关图书";
        return "查找相似";
      }
      return "查找相似";
    },
    getLastCardEndActionKey(val, group = "success") {
      if (!val) return null;
      let last = null;
      if (group === "fail") {
        if (this.canShowSimilarAction(val)) last = "similar";
        if (val.status == 7) last = "feedbackLink";
        return last;
      }
      if (this.canShowTranslationArea(val)) {
        if (this.canShowTranslationSubmit(val)) last = "translationSubmit";
        if (this.canShowTranslationPreview(val)) last = "translationPreview";
        if (this.canShowTranslationResult(val)) last = "translationResult";
      }
      if (this.canShowSimilarAction(val)) last = "similar";
      if (val.short_link && val.short_link.length > 0) last = "link";
      return last;
    },
    isCardEndActionAccent(val, actionKey, group = "success") {
      return this.getLastCardEndActionKey(val, group) === actionKey;
    },
    getSimilarQueryText(val) {
      const text = (val && (val.content || val.original)) || "";
      return String(text)
        .replace(/<[^>]+>/g, "")
        .trim();
    },
    handleSimilarAction(val) {
      if (val.similar_url && (val.demand_code === "zhBook" || val.demand_code === "中文书")) {
        window.open(val.similar_url, "_blank");
        return;
      }
      this.fetchSimilarRecommend(val);
    },
    fetchSimilarRecommend(val) {
      this.similarRowCopy = val;
      this.similarDialogVisible = true;
      this.similarLoading = true;
      this.similarList = [];
      this.similarPage = 0;
      this.similarExpanded = false;
      const that = this;
      $.ajax({
        url: process.env.VUE_APP_API_BASE_URL + "user/similar_recommend/",
        type: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          text: this.getSimilarQueryText(val),
          text_code: val.demand_code,
          task_id: val.task_id,
          status: val.status,
        },
        success(res) {
          that.similarLoading = false;
          if (res.error_code == 0) {
            that.similarPage = 0;
            that.similarExpanded = false;
            that.similarList = res.data || [];
            if (that.similarList.length > 0) {
              that.similarDialogVisible = true;
            } else {
              that.similarDialogVisible = true;
              that.$message.warning("暂无更多数据！！");
            }
          } else if (res.error_code == 1) {
            that.similarDialogVisible = true;
            that.$message.warning(res.msg || "暂无更多数据！！");
          }
        },
        error() {
          that.similarLoading = false;
          that.similarDialogVisible = false;
        },
      });
    },
    prevSimilarPage() {
      if (this.similarSubmitText === "提交中") return;
      if (this.similarPage > 0) {
        this.similarPage--;
        this.similarExpanded = false;
      }
    },
    nextSimilarPage() {
      if (this.similarSubmitText === "提交中") return;
      if (this.similarPage < this.similarList.length - 1) {
        this.similarPage++;
        this.similarExpanded = false;
      }
    },
    submitSimilarDemand() {
      if (this.similarSubmitText === "提交中" || !this.similarList.length) {
        return;
      }
      const current = this.similarList[this.similarPage];
      if (!current) return;

      let mes = {};
      try {
        mes = JSON.parse(sessionStorage.getItem("mes") || "{}");
      } catch (e) {
        mes = {};
      }

      let text_ = "";
      if (current.isbn) {
        text_ = current.isbn;
      } else if (current.doi) {
        text_ = current.doi;
      } else {
        text_ = current.title;
      }

      const cue = {
        type: 2,
        text: text_,
        quote_id: null,
        organ_code: mes.org_code || this.organ_code_copy,
        force_type: 2,
        is_artificial: 0,
        force_submint: true,
      };

      this.similarSubmitText = "提交中";
      const that = this;
      if (this.similarSubmitAjax) {
        this.similarSubmitAjax.abort();
      }
      this.similarSubmitAjax = $.ajax({
        url: process.env.VUE_APP_API_BASE_URL + "user/consultation/",
        data: JSON.stringify(cue),
        type: "Post",
        headers: {
          token: localStorage.getItem("token"),
        },
        processData: false,
        contentType: false,
        timeout: 1000 * 60 * 2,
        complete(XMLHttpRequest) {
          that.similarSubmitText = "提交查找";
          that.similarSubmitAjax = null;
          if (XMLHttpRequest.responseJSON) {
            const responseJson = XMLHttpRequest.responseJSON;
            if (responseJson.error_code === 0) {
              that.$message.success(responseJson.msg || "提交成功");
              that.similarDialogVisible = false;
              that.reloadMessageList();
            } else {
              that.$message.error(responseJson.msg || "提交失败");
            }
          }
        },
      });
    },
    closeSimilarDialog() {
      this.similarDialogVisible = false;
      this.similarLoading = false;
      this.similarList = [];
      this.similarPage = 0;
      this.similarExpanded = false;
      this.similarSubmitText = "提交查找";
      this.similarRowCopy = null;
      if (this.similarSubmitAjax) {
        this.similarSubmitAjax.abort();
        this.similarSubmitAjax = null;
      }
    },
    // --- 提交翻译 ---
    collectMessageTaskIds(list) {
      const ids = new Set();
      (list || []).forEach((record) => {
        const msg = (record && record.message) || {};
        ["success", "fail"].forEach((key) => {
          if (!Array.isArray(msg[key])) return;
          msg[key].forEach((item) => {
            if (item && item.task_id) {
              ids.add(String(item.task_id));
            }
          });
        });
      });
      return [...ids];
    },
    collectTaskIdDateRange(list, taskIds) {
      const taskIdSet = new Set((taskIds || []).map(String));
      const timestamps = [];

      const appendTime = (value) => {
        const time = this.parseDemandDateTime(value);
        if (time) timestamps.push(time);
      };

      (list || []).forEach((record) => {
        const msg = (record && record.message) || {};
        let recordMatched = false;

        ["success", "fail"].forEach((key) => {
          if (!Array.isArray(msg[key])) return;
          msg[key].forEach((item) => {
            if (item && item.task_id && taskIdSet.has(String(item.task_id))) {
              recordMatched = true;
              appendTime(item.complete_time);
            }
          });
        });

        if (recordMatched) {
          appendTime(record.create_time);
        }
      });

      if (!timestamps.length) {
        return { start_date: "", end_date: "" };
      }

      const minTime = Math.min(...timestamps);
      const maxTime = Math.max(...timestamps);
      return {
        start_date: this.formatDemandDate(new Date(minTime)),
        end_date: this.formatDemandDate(new Date(maxTime)),
      };
    },
    parseDemandDateTime(value) {
      if (value === undefined || value === null || value === "") return null;
      const str = String(value).trim();
      if (!str) return null;
      const normalized = str.replace(/T/, " ").replace(/-/g, "/");
      const date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return null;
      return date.getTime();
    },
    formatDemandDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    syncTranslationDemandStates(list) {
      const taskIds = this.collectMessageTaskIds(list);
      if (!taskIds.length) {
        return Promise.resolve();
      }
      const dateRange = this.collectTaskIdDateRange(list, taskIds);
      const que = { uc: localStorage.getItem("code") || "" };

      return newDemandCheck({
        task_id: taskIds.join(","),
        page: 1,
        size: Math.max(taskIds.length, 10),
        sort_by: "time_desc",
        con_type: ["all"],
        status: ["all"],
        start_date: dateRange.start_date,
        end_date: dateRange.end_date,
        content: "",
        read: 0,
        source: 0,
      }, que)
        .then((res) => {
          if (
            res.data &&
            res.data.data &&
            Array.isArray(res.data.data.data)
          ) {
            return this.processTranslationDemandData(res.data.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    processTranslationDemandData(items) {
      const map = { ...this.translationDemandMap };
      const formatPayload = [];

      items.forEach((item) => {
        const row = { ...item };
        if (
          (row.status == 4 || row.status == 5) &&
          row.short_link &&
          row.short_link.length > 0
        ) {
          row.down_file = this.translationDisposeUrl(row);
        } else {
          row.down_file = [];
        }

        const down_url = (row.down_url || []).join(",");
        const url_or = down_url.includes("下载地址");
        if (url_or) {
          const parts = down_url.split("下载地址");
          row.urls = parts
            .map((part) => part.match(/https?:\/\/[^\s]+/g))
            .filter(Boolean)
            .flat();
        } else {
          row.urls = down_url ? down_url.split(",") : [];
        }

        if (
          (row.status == 4 || row.status == 5) &&
          down_url !== "" &&
          row.urls[0] &&
          row.demand_code !== "zhBook" &&
          row.demand_code !== "enBook"
        ) {
          row.urls.forEach((itemUrl) => {
            if (itemUrl) {
              formatPayload.push({
                id: row.id,
                url: itemUrl,
              });
            }
          });
        }

        if (row.task_id) {
          map[String(row.task_id)] = row;
        }
      });

      this.translationDemandMap = map;

      if (formatPayload.length > 0) {
        return getfileformat({ result_data: formatPayload })
          .then((res) => {
            if (res.data && res.data.data) {
              res.data.data.forEach((fmt) => {
                Object.keys(map).forEach((key) => {
                  if (map[key].id === fmt.id && fmt.file_extension) {
                    map[key].file_extension = fmt.file_extension;
                  }
                });
              });
              this.translationDemandMap = { ...map };
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.fetchTranslationHistoryFileList();
          });
      }

      return this.fetchTranslationHistoryFileList();
    },
    translationDisposeUrl(row) {
      const formUrl = [];
      const short_link = (row.short_link || []).join(",");
      if (short_link.indexOf("文档密码：") !== -1) {
        const pass = short_link.split("文档密码：");
        formUrl.push({
          url: pass[0],
          password: pass[1].slice(0, 4),
          passType: 1,
        });
      } else if (short_link.indexOf("提取码：") !== -1) {
        const pass = short_link.split("提取码：");
        formUrl.push({
          url: pass[0],
          password: pass[1].slice(0, 4),
          passType: 2,
        });
      } else if (short_link.indexOf(",") !== -1) {
        short_link.split(",").forEach((item) => {
          const urls_ = item.replace(/\n/g, "      ");
          if (urls_.indexOf("      ") !== -1) {
            urls_.split("      ").forEach((part) => {
              if (part.indexOf("http:") !== -1) {
                formUrl.push({
                  url: part.substring(part.lastIndexOf("http:")),
                  passType: 0,
                });
              }
            });
          } else {
            formUrl.push({ url: item, passType: 0 });
          }
        });
      } else {
        const urls = short_link.replace(/\n/g, "      ");
        if (urls.indexOf("      ") !== -1) {
          urls.split("      ").forEach((item) => {
            if (item.indexOf("http:") !== -1) {
              formUrl.push({
                url: item.substring(item.lastIndexOf("http:")),
                passType: 0,
              });
            }
          });
        } else if (short_link) {
          formUrl.push({ url: short_link, passType: 0 });
        }
      }
      return formUrl;
    },
    fetchTranslationHistoryFileList() {
      return getData({ page: 1 })
        .then((res) => {
          if (res.data.status == 0) {
            this.translationHistoryFileList = res.data.data || [];
          } else {
            this.translationHistoryFileList = [];
          }
          const map = { ...this.translationDemandMap };
          Object.keys(map).forEach((key) => {
            const row = map[key];
            if (!row.yicai_task_id) return;
            const matched = this.translationHistoryFileList.filter(
              (task) => task.task_id === row.yicai_task_id
            );
            if (matched.length > 0) {
              row.yicai_status = matched[0].task_status;
            }
          });
          this.translationDemandMap = map;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchTranslationRemainderNumber() {
      return wenNumber()
        .then((res) => {
          if (res.data.data && res.data.data.remaining) {
            // this.translationRemainderNumber =
            //   res.data.data.remaining["翻译/总量"];
            const remaining = res.data.data.remaining;
            const translationKey = Object.keys(remaining).find((key) =>
              key.startsWith("翻译/")
            );
            this.translationRemainderNumber = translationKey
              ? remaining[translationKey]
              : 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTranslationDemand(val) {
      if (!val || !val.task_id) return null;
      return this.translationDemandMap[String(val.task_id)] || null;
    },
    mergeTranslationRow(val) {
      const demand = this.getTranslationDemand(val);
      return demand ? { ...val, ...demand } : val;
    },
    canShowTranslationArea(val) {
      if (!val || !val.task_id) return false;
      return (
        this.canShowTranslationSubmit(val) ||
        this.canShowTranslationPreview(val) ||
        this.canShowTranslationResult(val)
      );
    },
    canShowTranslationSubmit(val) {
      const row = this.mergeTranslationRow(val);
      return (
        !row.isefficacy &&
        row.file_extension === ".PDF" &&
        !row.yicai_task_id &&
        !row.translation_status &&
        ["enDoc", "PMID", "PMC", "DOI"].includes(row.demand_code)
      );
    },
    canShowTranslationPreview(val) {
      const row = this.mergeTranslationRow(val);
      return row.translation_status == 1 && !row.isefficacy;
    },
    canShowTranslationResult(val) {
      const row = this.mergeTranslationRow(val);
      return row.translation_status == 2 && !row.isefficacy;
    },
    isTranslationSubmitting(val) {
      return (
        val &&
        val.task_id &&
        this.translationSubmittingTaskId === String(val.task_id)
      );
    },
    handleTranslationSubmit(val) {
      if (this.translationRemainderNumber <= 0) {
        this.$message({
          message: "您的文档翻译次数已达上限！",
          type: "warning",
        });
        return;
      }
      this.translationRowCopy = val;
      this.dialogTranslation = true;
    },
    confirmTranslationSubmit() {
      const row = this.mergeTranslationRow(this.translationRowCopy);
      if (!row || !row.task_id) {
        this.dialogTranslation = false;
        return;
      }
      if (this.translationSubmittingTaskId) {
        return;
      }
      this.translationSubmittingTaskId = String(row.task_id);
      this.dialogTranslation = false;
      this.translationProcessUrls(row);
    },
    translationRelevancyId(obg) {
      const taskId = obg && obg.task_id ? String(obg.task_id) : "";
      newYiCaiTask_id(obg)
        .then(() => {
          if (this.translationRemainderNumber > 0) {
            this.translationRemainderNumber -= 1;
          }
          this.syncTranslationDemandStates(this.messageData);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.clearTranslationSubmitting(taskId);
        });
    },
    clearTranslationSubmitting(taskId) {
      if (taskId && this.translationSubmittingTaskId === String(taskId)) {
        this.translationSubmittingTaskId = "";
      }
    },
    async translationProcessUrls(row) {
      const urls = row.urls || [];
      console.log('urls.length',urls.length)
      if (!urls.length) {
        this.$message.error("PDF文件请求失败，暂不支持翻译");
        this.clearTranslationSubmitting(row.task_id);
        return;
      }
      for (const url of urls) {
        try {
          const pdf_name = row.task_id + "_" + new Date().getTime() + ".pdf";
          const res = await axios.get(
            "https://journal.codo.my/new_download_file",
            {
              params: { url },
              responseType: "blob",
            }
          );
          if (!res || !res.data) continue;

          const text = await res.data.text();
          let parsedData;
          try {
            parsedData = JSON.parse(text);
          } catch (error) {
            parsedData = null;
          }

          if (parsedData && parsedData.code === 0) {
            continue;
          }

          const blob = new Blob([res.data]);
          const file = new File([blob], pdf_name, { type: blob.type });
          const formData = new FormData();
          formData.append("file", file);
          formData.append("langFrom", "en");
          formData.append("langTo", "zh");
          formData.append("filename", pdf_name);

          const uploadResponse = await axios.post(
            process.env.VUE_APP_API_BASE_URL +
            "extend/upload_translation_file/",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                token: window.localStorage.getItem("token"),
              },
            }
          );

          if (uploadResponse.data.error_code == 0) {
            const yicaiTaskId = uploadResponse.data.data.task_id;
            this.translationRelevancyId({
              task_id: row.task_id,
              yicai_task_id: yicaiTaskId,
            });
            return;
          }

          this.$message.error(uploadResponse.data.msg);
          this.clearTranslationSubmitting(row.task_id);
          return;
        } catch (error) {
          console.log(error);
        }
      }
      this.$message.error("PDF文件请求失败，暂不支持翻译");
      this.clearTranslationSubmitting(row.task_id);
    },
    handleTranslationPreview(val) {
      const row = this.mergeTranslationRow(val);
      if (!row || !row.yicai_task_id) return;
      download_ql({
        task_id: row.yicai_task_id,
        type: "1",
      })
        .then((res) => {
          if (res.data.error_code == 0) {
            if (res.data.data) {
              const url_ = this.$router.resolve({
                path: "/filePreview",
                query: {
                  file: res.data.data.replace(/^http:\/\//, "https://"),
                  langTo: "zh",
                },
              }).href;
              window.open(url_, "_blank");
            } else {
              this.$message.error("暂无文件！");
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleTranslationDownload(val, command) {
      const row = this.mergeTranslationRow(val);
      if (!row || !row.yicai_task_id || !command) return;

      if (command === "online") {
        const url_ = this.$router.resolve({
          path: "/preview",
          query: {
            task_id: row.yicai_task_id,
            langTo: "zh",
            langFrom: "en",
          },
        }).href;
        window.open(url_, "_blank");
        return;
      }

      const parts = command.split(":");
      const version = parts[0];
      const fileType = parts[1] || "";
      this.translationHandleDownLoad(row.yicai_task_id, version, fileType);
    },
    translationHandleDownLoad(id, version, type) {
      const down_id = {
        task_id: id,
        type:
          version == "translate"
            ? type == "pdf"
              ? "2"
              : "4"
            : version == "origin"
              ? "1"
              : version == "compare"
                ? "3"
                : "1",
      };
      download_ql(down_id)
        .then((res) => {
          if (res.data.status == 0) {
            if (res.data.data[0].status == 0) {
              window.open(res.data.data[0].url, "_blank");
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.dialogUrl = [];
    },
    numberToChinese(num) {
      const map = {
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
        10: "十",
      };
      return map[num] || num; // 如果不在范围内，返回原值
    },
    openLink01(links) {
      window.open(links, "_blank");
    },
    copyLink01(item) {
      //创建一个 Input标签
      let oInput = document.createElement("input");
      oInput.value = item;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      // 执行浏览器复制命令
      /// 复制命令会将当前选中的内容复制到剪切板中
      /// 如这里构建的 Input标签
      document.execCommand("Copy");
      this.$message({
        message: "链接复制成功",
        type: "success",
      });
      ///复制成功后再将构造的标签 移除
      oInput.remove();
    },
    // 错误反馈
    handleErrFeedbackCommand(val, reason) {
      if (this.submit_or_copy) {
        this.$message.warning("正在处理中，请稍候");
        return;
      }
      const taskId = val && val.task_id;
      if (!taskId) {
        this.$message({
          message: "无法获取该条需求的任务编号，请稍后重试",
          type: "warning",
        });
        return;
      }
      // if (reason === "链接地址无法访问") {
      //   this.openLinkUnreachableDialog(taskId);
      //   return;
      // }
      if (reason === "其他") {
        this.errFeedbackForm = {
          task_id: taskId,
          msg: "",
        };
        this.dialogErrFeedback = true;
        this.$nextTick(() => {
          this.$refs.errFeedbackFormRef &&
            this.$refs.errFeedbackFormRef.clearValidate();
        });
        return;
      }
      this.submitErrFeedback(taskId, reason);
    },
    getUserMesEmail() {
      try {
        const mes = JSON.parse(sessionStorage.getItem("mes") || "{}");
        const email = mes.email;
        const code = mes.code;
        if (!email || email === code) {
          return "";
        }
        const reg =
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return reg.test(email) ? email : "";
      } catch (e) {
        return "";
      }
    },
    maskUserEmail(email) {
      if (!email) {
        return "";
      }
      const atIndex = email.indexOf("@");
      if (atIndex <= 0) {
        return email;
      }
      const local = email.slice(0, atIndex);
      const domain = email.slice(atIndex + 1);
      if (local.length <= 4) {
        return `${local.charAt(0)}*****${local.slice(-1)}@${domain}`;
      }
      return `${local.slice(0, 3)}*****${local.slice(-4)}@${domain}`;
    },
    openLinkUnreachableDialog(taskId) {
      const userEmail = this.getUserMesEmail();
      this.linkUnreachableHasEmail = !!userEmail;
      this.linkUnreachableUserEmail = userEmail;
      this.linkUnreachableForm = {
        task_id: taskId,
        email: "",
        email_code: "",
      };
      this.dialogLinkUnreachable = true;
      this.$nextTick(() => {
        this.$refs.linkUnreachableFormRef &&
          this.$refs.linkUnreachableFormRef.clearValidate();
      });
    },
    closeLinkUnreachableDialog() {
      this.stopLinkUnreachableCodeCountdown();
      this.linkUnreachableSubmitting = false;
      this.linkUnreachableForm = {
        task_id: "",
        email: "",
        email_code: "",
      };
      this.linkUnreachableHasEmail = false;
      this.linkUnreachableUserEmail = "";
    },
    startLinkUnreachableCodeCountdown() {
      this.stopLinkUnreachableCodeCountdown();
      this.linkUnreachableCodeCountdown = 60;
      this.linkUnreachableCodeTimer = setInterval(() => {
        if (this.linkUnreachableCodeCountdown > 1) {
          this.linkUnreachableCodeCountdown -= 1;
        } else {
          this.stopLinkUnreachableCodeCountdown();
        }
      }, 1000);
    },
    stopLinkUnreachableCodeCountdown() {
      if (this.linkUnreachableCodeTimer) {
        clearInterval(this.linkUnreachableCodeTimer);
        this.linkUnreachableCodeTimer = null;
      }
      this.linkUnreachableCodeCountdown = 0;
    },
    sendLinkUnreachableEmailCode() {
      const email = (this.linkUnreachableForm.email || "").trim();
      if (!email) {
        this.$message.warning("请输入邮箱地址");
        return;
      }
      const reg =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!reg.test(email)) {
        this.$message.warning("请输入有效的邮箱地址");
        return;
      }
      if (this.linkUnreachableCodeCountdown > 0) {
        return;
      }
      emailRegister({
        new_email: email,
      })
        .then((res) => {
          if (res.data.error_code == 0) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.startLinkUnreachableCodeCountdown();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.stopLinkUnreachableCodeCountdown();
        });
    },
    confirmLinkUnreachableFeedback() {
      if (this.linkUnreachableSubmitting) {
        return;
      }
      const taskId = this.linkUnreachableForm.task_id;
      if (!taskId) {
        this.$message.warning("无法获取该条需求的任务编号，请稍后重试");
        return;
      }
      if (this.linkUnreachableHasEmail) {
        this.dialogLinkUnreachable = false;
        this.submitErrFeedback(taskId, "链接地址无法访问");
        return;
      }
      this.$refs.linkUnreachableFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.linkUnreachableSubmitting = true;
        let mes = {};
        try {
          mes = JSON.parse(sessionStorage.getItem("mes") || "{}");
        } catch (e) {
          mes = {};
        }
        userComplete({
          user_id: mes.user_id,
          organ_code: mes.org_code,
          email: (this.linkUnreachableForm.email || "").trim(),
          email_code: (this.linkUnreachableForm.email_code || "").trim(),
        })
          .then((res) => {
            if (res.data.error_code == 0) {
              mes.email = (this.linkUnreachableForm.email || "").trim();
              sessionStorage.setItem("mes", JSON.stringify(mes));
              this.dialogLinkUnreachable = false;
              this.submitErrFeedback(taskId, "链接地址无法访问");
              return;
            }
            this.$message.error(res.data.msg);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.linkUnreachableSubmitting = false;
          });
      });
    },
    closeErrFeedbackDialog() {
      this.errFeedbackForm = { task_id: "", msg: "" };
    },
    submitErrFeedbackOther() {
      this.errFeedbackForm.msg = (this.errFeedbackForm.msg || "").replace(
        /\s*/g,
        ""
      );
      this.$refs.errFeedbackFormRef.validate((valid) => {
        if (!valid) return false;
        this.submitErrFeedback(
          this.errFeedbackForm.task_id,
          this.errFeedbackForm.msg,
          { closeDialog: true }
        );
      });
    },
    submitErrFeedback(task_id, msg, options = {}) {
      this.submit_or_copy = true;
      this.cue_text = "";
      this.$nextTick(() => {
        this.scrollToBottom();
      });

      errorFeedback({
        task_id,
        msg,
      })
        .then((res) => {
          if (res.data.error_code == 0) {
            if (options.closeDialog) {
              this.dialogErrFeedback = false;
              this.errFeedbackForm = { task_id: "", msg: "" };
            }
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.reloadMessageList();
          } else {
            this.submit_or_copy = false;
            this.cue_text = "";
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.submit_or_copy = false;
          this.cue_text = "";
          console.log(err);
        });
    },
    openFeedbackStatus7(val) {
      const taskId = val && val.task_id;
      if (!taskId) {
        this.$message({
          message: "无法获取该条需求的任务编号，请稍后重试",
          type: "warning",
        });
        return;
      }
      this.feedbackForm = {
        task_id: taskId,
        msg: "",
      };
      this.dialogFeedback = true;
      this.$nextTick(() => {
        this.$refs.feedbackFormRef &&
          this.$refs.feedbackFormRef.clearValidate();
      });
    },
    closeFeedbackDialog() {
      this.feedbackForm = { task_id: "", msg: "" };
    },
    validateFeedback7ForSubmit(value) {
      const raw = (value || "").trim();
      if (!raw) {
        return "请补充提供需求的原始链接地址";
      }
      const lines = raw
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter(Boolean);
      const parts = lines.length ? lines : [raw];
      const hasScheme = /^https?:\/\/.+/i;
      for (let i = 0; i < parts.length; i++) {
        const line = parts[i];
        if (!hasScheme.test(line)) {
          return "请填写以 http:// 或 https:// 开头的完整链接地址";
        }
        let u;
        try {
          u = new URL(line);
        } catch (e) {
          return "请输入有效的链接地址";
        }
        if (u.protocol !== "http:" && u.protocol !== "https:") {
          return "请输入有效的 http/https 链接地址";
        }
        const host = u.hostname;
        if (!host) {
          return "请输入有效的链接地址";
        }
        const plausibleHost =
          host === "localhost" ||
          /^(\d{1,3}\.){3}\d{1,3}$/.test(host) ||
          host.includes(".");
        if (!plausibleHost) {
          return "请输入有效的链接地址";
        }
      }
      return null;
    },
    submitFeedbackStatus7() {
      this.feedbackForm.msg = (this.feedbackForm.msg || "").trim();
      this.$refs.feedbackFormRef.validate((valid) => {
        if (!valid) return false;
        errorFeedback({
          task_id: this.feedbackForm.task_id,
          msg: this.feedbackForm.msg,
        }).then((res) => {
          if (res.data.error_code == 0) {
            this.dialogFeedback = false;
            this.feedbackForm = { task_id: "", msg: "" };
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.reloadMessageList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    // 确认提交错误反馈
    confirmErrFeedback(msg, task_id) {
      setTimeout(() => {
        this.textarea_txt = "";
        this.cite_data_copy = {};
      }, 800);
      errorFeedback({
        task_id,
        msg,
      }).then((res) => {
        if (res.data.error_code == 0) {
          this.reloadMessageList();
        }
      });
    },
    close_icon() {
      this.cite_data_copy = {};
      this.adjustDivHeight();
    },
    progressfile() {
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
    },
    succesfile(res) {
      if (res.error_code == 0) {
        if (res.data[1] == null || res.data[1].length == 0) {
          Toast("无法识别");
        } else {
          this.textarea_txt = "";
          res.data[1].map((item) => {
            this.textarea_txt += item.words + "\n";
          });
          this.lookup_sub();
          Toast.clear();
        }
      } else {
        Toast("无法识别");
      }
    },
    or_msg(text_s) {
      let count = 0;
      for (let key in text_s) {
        if (text_s[key].code === 0) {
          count++;
        }
      }
      return count;
    },
    or_msg_c(text_s, quote_text) {
      let count = true;

      for (let key in text_s) {
        if (text_s[key].text == quote_text) {
          count = false;
        }
      }
      return count;
    },
    getTimeText(argument) {
      var timeS = argument;
      var todayT, yestodayT;
      var timeCha = this.getTimeS(timeS);
      // 获取今天开始时间 (00:00:00.000) 的毫秒数
      var todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      // 从今天开始到现在的时间（以毫秒为单位）
      todayT = Date.now() - todayStart.getTime();
      // 昨天的时间（以毫秒为单位），从昨天开始算起
      yestodayT = todayT + 24 * 60 * 60 * 1000;
      // 提取时间部分 (HH:mm:ss)
      timeS = timeS.slice(-8);
      if (timeCha > yestodayT) {
        argument = argument.replace(/T/, " ");
        return argument.slice(5, 11) + timeS.slice(0, 5);
      }
      if (timeCha > todayT && timeCha < yestodayT) {
        return "昨天" + " " + timeS.slice(0, 5);
      }
      if (timeCha < todayT) {
        return timeS.slice(0, 2) >= 12
          ? "下午" +
          (timeS.slice(0, 2) == 12 ? 12 : timeS.slice(0, 2) - 12) +
          timeS.slice(2, 5)
          : "上午" + timeS.slice(0, 5);
      }
    },

    getTimeS(timeS) {
      // 将时间字符串转换为 Date 对象，考虑到时区问题
      timeS = timeS.replace(/T/, " ");
      timeS = timeS.replace(/[-]/g, "/");
      return Date.now() - new Date(timeS).getTime();
    },
    // 时间戳转年月日
    formatDate(data) {
      let now = new Date(data);
      var year = now.getFullYear(); //取得4位数的年份
      var month =
        now.getMonth() + 1 < 10
          ? "0" + (now.getMonth() + 1)
          : now.getMonth() + 1;
      var date = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
      var hour = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
      var minute =
        now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
      var second =
        now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    formatTime(timeStr) {
      // 创建 Date 对象
      let date = new Date(timeStr.replace(/T/, " ").replace(/-/g, "/"));

      // 格式化为 YYYY-MM-DD HH:mm:ss
      let formattedDate =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0") +
        " " +
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0") +
        ":" +
        String(date.getSeconds()).padStart(2, "0");
      return formattedDate;
    },
    formattedText(text) {
      // 替换特定 URL 为 <a> 标签，并将换行符替换为 <br>
      return text
        .replace("http://s.dic.cool/S/jwZKDP6B", (match) => {
          return `<a href="${match}" style="color: #409eff;" target="_blank">${match}</a>`;
        })
        .replace(/\n/g, "<br>");
    },
    flushedAutomatic() {
      if (this.isReloadingMessages) {
        return;
      }
      let messageQuery_ = {
        size: 10,
        new_data: "",
        search: "",
        last_id: "",
        type: 2,
        direction: "up",
      };
      messagerecordData(messageQuery_)
        .then((res) => {
          if (res.data.error_code == 0) {
            const fetchedList = res.data.data.data.map((item) =>
              this.parseMessageRecordItem(item)
            );
            const prevById = new Map(
              this.messageData.map((item) => [item.id, item])
            );
            const mergedMap = new Map(
              this.messageData.map((item) => [item.id, item])
            );
            fetchedList.forEach((item) => {
              mergedMap.set(item.id, item);
            });
            const mergedArray = this.sortMessageRecords([...mergedMap.values()]);

            const hasNewMessages = mergedArray.length > this.messageData.length;
            const hasContentUpdate = fetchedList.some((item) => {
              const prev = prevById.get(item.id);
              if (!prev) return false;
              return (
                JSON.stringify(prev.message) !== JSON.stringify(item.message)
              );
            });
            const hasNewFetchedMessages = fetchedList.some(
              (item) => !prevById.has(item.id)
            );

            if (!hasNewMessages && !hasContentUpdate && !hasNewFetchedMessages) {
              return;
            }

            const container = document.getElementById("myDiv");
            if (!container) return;

            // 判断是否在最底部
            const isScrolledToBottom =
              container.scrollHeight - container.scrollTop ===
              container.clientHeight;
            this.messageData = mergedArray;
            this.syncTranslationDemandStates(this.messageData);
            this.$nextTick(() => {
              this.submit_or = false;
              if (isScrolledToBottom) {
                container.scrollTop = container.scrollHeight;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitHandle(options = {}) {
      const shouldClear = options.shouldClear;
      this.picked_id = 1;
      this.$nextTick(() => {
        this.reloadMessageList().finally(() => {
          this.scrollToBottomAfterRender();
          if (shouldClear && this.$refs.retrievalRef) {
            this.$refs.retrievalRef.clearHandle();
          }
        });
      });
    },
    // 强制提交
    async forceSubmintHandle(item) {
      if (this.shake_or || this.submit_or_copy) {
        this.$message.warning("正在处理中，请稍候");
        return;
      }

      const userText = this.getForceSubmitUserText(item);
      const demand = item.message && item.message.demand;

      if (userText) {
        this.textarea_txt = userText;
        this.cue.text = userText;
        this.cue_text_copy = userText;
        this.consultationAi("compulsion");
        return;
      }

      if (demand && demand.length) {
        this.submit_or_copy = true;
        this.cue_text = "";
        try {
          const res = await newDemandPost({ demand });
          if (res.data.error_code === 0) {
            this.$message.success(res.data.msg || "提交成功");
            await new Promise((resolve) => setTimeout(resolve, 800));
            await this.reloadMessageList();
          } else {
            this.submit_or_copy = false;
            this.$message.warning(res.data.msg || "提交失败");
          }
        } catch (err) {
          this.submit_or_copy = false;
          console.log(err);
        }
        return;
      }

      this.$message.warning("无法获取原始需求内容");
    },
    isValidJSON(str) {
      console.log(typeof str, typeof str == "object");
      if (typeof str !== "string") {
        return false;
      }
      try {
        const result = JSON.parse(str);

        return typeof result === "object" && result !== null;
      } catch (e) {
        return false;
      }
    },
    getDemandCodeLabel(code) {
      return (this.codeType[code] && this.codeType[code].text) || code || "";
    },
    isEmergencyMessage(val) {
      return val && val.status === 8;
    },
    isManualAssistantReply(val) {
      return val && Number(val.artificial_status) === 2;
    },
    hasEmergencyMessage(item) {
      if (!item || !item.message) return false;
      const results = [
        ...(item.message.success || []),
        ...(item.message.fail || []),
      ];
      return results.some((val) => this.isEmergencyMessage(val));
    },
    getEmergencyQuoteText(val) {
      if (!val) return "";
      return val.original || val.content || "";
    },
    getManualReplyText(val) {
      if (!val) return "";
      return val.leave_word || val.fail_reason || val.content || "";
    },
    formatMultilineText(text) {
      if (!text) return "";
      return String(text)
        .replace(/\\n/g, "\n")
        .replace(/\n/g, "<br>");
    },
    getAiReplyMainText(text) {
      if (!text) return "";
      return text.replace(/(\([^)]*\)[。]?)$/, "").trim();
    },
    getAiReplyHintText(text) {
      if (!text) return "";
      const match = text.match(/(\([^)]*\)[。]?)$/);
      return match ? match[1] : "";
    },
    shouldShowAiResultReturn(item) {
      if (!item || !item.message) return true;
      const processing = item.message.processing || [];
      return processing.length === 0;
    },
    syncProcessingHint(show) {
      this.resetProcessingHint();
      if (!show || !this.submit_or_copy) return;
      this.processingHintTimer = setTimeout(() => {
        if (this.isProcessingLoading && this.submit_or_copy) {
          this.processingHintVisible = true;
        }
        this.processingHintTimer = null;
      }, 1000);
    },
    resetProcessingHint() {
      if (this.processingHintTimer) {
        clearTimeout(this.processingHintTimer);
        this.processingHintTimer = null;
      }
      this.processingHintVisible = false;
    },
    isProcessingDetailsOpen(item) {
      return item.processingDetailsOpen !== false;
    },
    toggleProcessingDetails(item) {
      this.$set(item, "processingDetailsOpen", !this.isProcessingDetailsOpen(item));
    },
    getAnalysisHeadTime(item) {
      const timeValue = item && (item.create_time || item.update_time);
      if (!timeValue) return "";
      const normalized = String(timeValue).replace(/T/, " ").replace(/-/g, "/");
      const date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return "";
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    hasResultCardMeta(val) {
      if (!val) return false;
      const metaFields = [
         "title",
        "author",
        "journal_name",
        "year",
        // "publisher",
        "doi",
        "isbn",
        "standard_status",
        "password",
      ];
      return metaFields.some((field) => {
        const value = val[field];
        return value !== undefined && value !== null && value !== "";
      });
    },
    isResultCardOpen(val) {
      return val.resultCardOpen !== false;
    },
    toggleResultCard(val) {
      this.$set(val, "resultCardOpen", !this.isResultCardOpen(val));
    },
    getFailStatusLabel(val) {
      return val.status == 7 ? "疑似AI文献" : "处理失败";
    },
    getFailStatusClass(val) {
      return val.status == 7 ? "status-fake" : "status-error";
    },
  },
  beforeDestroy() {
    this.exitComposerFullscreen();
    if (this.intervalId) {
      this.clear();
    }
    this.resetProcessingHint();
    this.stopLinkUnreachableCodeCountdown();
    if (this.similarSubmitAjax) {
      this.similarSubmitAjax.abort();
      this.similarSubmitAjax = null;
    }
  },
  components: {
    RETRIEVAL,
  },
};
</script>

<style lang="less" scoped>
@chat-content-width: 800px;

.app_box {
  // background: #f9f0f4;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
  height: calc(100vh - 120px);
  padding-top: 52px;
  box-sizing: border-box;
  overflow: hidden;
}

.app_css {
  width: 100%;
  // margin: 0 20%;
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.chat-layout {
  display: grid;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr) auto;
}

.chat-layout.layout-top {
  grid-template-rows: auto minmax(0, 1fr);
}

.chat-content {
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.composer-footer {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
}

.ai_css {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.input_css {
  background: #ffffff;
  border-radius: 5px;
  width: 100%;
  max-width: @chat-content-width;
  margin: 0 auto;
  box-sizing: border-box;
  z-index: 10;
}

.composer-band {
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  height: 92px;
  padding-top: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: height 0.32s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  overflow: hidden;
}

.composer-expand-btn {
  position: absolute;
  top: 5px;
  right: 0px;
  z-index: 4;
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  color: #a9abb0;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s ease;

  &:hover {
    color: #666b75;
  }
}

.composer-expand-icon {
  display: block;
  width: 1em;
  height: 1em;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.6;
}

.composer-band.is-expanded:not(.is-fullscreen) {
  height: 188px;
}

.composer-band.is-fullscreen {
  height: calc(var(--composer-input-height, 160px) + 8px) !important;
  overflow: hidden;
  padding-top: 8px;
  box-sizing: border-box;
}

.composer {
  position: relative;
  width: 100%;
  height: 60px;
  margin: 0 auto;
  border: 1px solid #e1e1e2;
  border-radius: 16px;
  background: #fcfcfc;
  box-shadow: none;
  padding: 0 19px 0 18px ;
  box-sizing: border-box;
  transition: height 0.32s cubic-bezier(0.4, 0, 0.2, 1), border-radius 0.28s ease;
  cursor: text;
  overflow: hidden;
}

.composer.expanded:not(.is-fullscreen) {
  height: 160px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.composer.is-fullscreen {
  height: var(--composer-input-height, 160px) !important;
  transition: height 0.32s cubic-bezier(0.4, 0, 0.2, 1);
}

.composer.is-fullscreen .compact-prompt {
  display: none;
}

.composer.is-fullscreen textarea {
  display: block;
  opacity: 1;
  height: calc(var(--composer-input-height, 160px) - 48px);
}

.composer:not(.expanded):not(.is-fullscreen) {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 32px;
}

.composer-actions {
  position: absolute;
  left: 16px;
  right: 16px;
  top: auto;
  bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  height: 24px;
}

.composer:not(.expanded):not(.is-fullscreen) .compact-prompt {
  flex: 1;
  min-width: 0;
  padding-right: 8px;
}

.compact-prompt {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 58px;
  color: rgba(26, 26, 26, 0.36);
  font-size: 14px;
  line-height: 22px;
  overflow: hidden;
  cursor: text;
}

.compact-prompt span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.composer.expanded .compact-prompt {
  display: none;
}

.composer-label {
  display: none;
  position: absolute;
  left: 16px;
  top: 12px;
  width: calc(100% - 32px);
  min-width: 0;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  color: rgba(26, 26, 26, 0.36);
  font-size: 14px;
  line-height: 22px;
  pointer-events: none;
  white-space: nowrap;
  visibility: hidden;
  transition: max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.24s ease, visibility 0s linear 0.28s;
}

.composer-label span {
  display: block;
}

.composer textarea {
  display: none;
  position: absolute;
  left: 16px;
  top: 12px;
  width: calc(100% - 37px);
  min-width: 0;
  height: 98px;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  resize: none;
  overflow: auto;
  background: transparent;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 22px;
  font-family: inherit;
  opacity: 0;
  transition: opacity 0.24s ease;
}

.composer.expanded .composer-label,
.composer.is-fullscreen .composer-label {
  display: block;
}

.composer.expanded:not(.has-value) .composer-label,
.composer.is-fullscreen:not(.has-value) .composer-label {
  max-height: 120px;
  opacity: 1;
  visibility: visible;
  white-space: normal;
  transition: visibility 0s linear 0.08s, max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1) 0.08s, opacity 0.24s ease 0.08s;
}

.composer.expanded textarea {
  display: block;
  opacity: 1;
  transition: opacity 0.24s ease 0.12s;
}

.composer.has-value textarea {
  background: transparent;
  opacity: 1;
  transition: none;
}

.composer.has-value .composer-label {
  display: none;
  max-height: 0;
  opacity: 0;
  visibility: hidden;
}

.composer textarea::-webkit-scrollbar {
  width: 5px;
}

.composer textarea::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #b1b0b0;
}

.example-btn {
  border: 0;
  background: transparent;
  padding: 0;
  color: #e2426b;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}

.composer.expanded .example-btn {
  display: none;
}

.ask-btn {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 50%;
  background: #e2426b;
  color: #fff;
  padding: 4px;
  cursor: pointer;
}

.ask-btn svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.close_css {
  position: absolute;
  right: 60px;
  top: 3px;
  font-weight: 600;
  z-index: 100;
}

.btn_css_Send {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  // justify-content: space-between;
  // align-items: center;
  // padding: 3px 0 0 0;
  // width: 30px;

  .btn_tab,
  .btn_icon {
    cursor: pointer;
    // display: flex;
    //
    // align-items: center;
  }

  .el-button {
    width: 76px;
    height: 30px;
    line-height: 0;
    background: #f1f2f2;
    color: #a8aaae;
    border: none;
    margin-bottom: 4px;
  }

  .active {
    background: #e63b63;
    color: #fff;
  }
}

.btn_txt {
  font-size: 15px;
  letter-spacing: 1px;
}

.btn_yes {
  font-weight: 600;
  color: #e2426b;
}

.btn_no {
  color: #a8aaae;
}

.btn_icon_img {
  width: 27px;
  height: 27px;
  // margin-left: 10px;
  margin: 0px 5px 5px 15px;
}

.history_css {
  cursor: pointer;
  position: absolute;
  bottom: 3px;
  right: -35px;
}

.top_css {
  width: 100%;
}

.bottom_css {
  width: 100%;
}

.data_css {
  padding: 10px 20px;
  margin: 0;
  box-sizing: border-box;
}

.top_list_css {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/deep/ .el-loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom_list_css {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0 !important;
}

#myDiv::-webkit-scrollbar {
  // display: none;
}

#myDiv::-webkit-scrollbar {
  width: 5px;
  height: 1px;
}

#myDiv::-webkit-scrollbar-thumb {
  //滑块部分
  border-radius: 5px;
  background-color: #cac6c6;
}

#myDiv::-webkit-scrollbar-track {
  //轨道部分
  // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ffffff;
  border-radius: 5px;
}

#myDiv {
  height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}

.tit_txt {
  color: #e2426b;
  font-size: 16px;
  margin-bottom: 10px;
}

.identify_li_css {
  // box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
  background: white;
  //   padding: 10px 0 10px 10px;
  border-radius: 5px;
  margin-bottom: 10px;

  /deep/ .van-swipe-cell {
    width: 100%;
  }

  /deep/ .van-swipe-cell__wrapper {
    width: 100%;
  }
}

.li_css {
  padding: 10px;
  display: flex;
  align-items: center;
}

.li_box {
  width: calc(100% - 75px);

  .el-tag {
    background: #e2426b;
    color: white;
    text-align: center;
    min-width: 55px;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .li_box_txt {
    font-weight: 450;
    // line-height: 25px;
    margin-top: 5px;
    color: #353535;
    letter-spacing: 0.5px;
    white-space: nowrap; //文本强制不换行；
    text-overflow: ellipsis; //文本溢出显示省略号；
    overflow: hidden; //溢出的部分隐藏；
  }
}

.checkbox_col {

  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #e2426b;
    border-color: #e2426b;
  }

  /deep/ .el-checkbox__inner:hover {
    border-color: #e2426b;
  }
}

.li_btn {
  display: flex;
  align-items: center;
}

.right_css {
  display: flex;
  height: 100%;

  .right_btn {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;
    color: white;
    letter-spacing: 1px;
  }
}

.footer_submit {
  display: flex;
  justify-content: space-between;
  z-index: 999;

  align-items: center;
  padding: 15px 0;
}

.clear_result {
  text-align: center;
  width: 25%;
  padding: 10px 0px;
  box-sizing: border-box;
  color: #fff;
  background: #fa9a99;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}

.sumbit_selected {
  padding: 10px 0px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.5);
  background: #e2426b;
  color: #fff;
  border-radius: 5px;
  width: 40%;
  text-align: center;
}

.merge_result {
  color: #e2426b;
  border: #e2426b solid 1px;
  border-radius: 5px;
  width: 25%;
  text-align: center;
  padding: 10px 0;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

/deep/.van-dialog__confirm .van-button__text {
  color: #e2426b !important;
}

.edit_ruleForm_css {
  padding: 20px;

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
}

/deep/ .el-textarea__inner {
  border-color: #c0c4cc !important;
}

/deep/.el-input__inner {
  border-color: #c0c4cc !important;
}

.identify_li_s {
  height: calc(100vh - 360px);
  overflow-x: hidden;
  overflow-y: scroll;
}

.remark_box_css {
  padding: 20px;
}

.remark_tag_s {
  .el-tag {
    color: #7b7777;
    margin-right: 10px;
  }
}

.message_li_css {
  display: flex;
}

.msg_txt_ {
  max-width: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;

  &--user {
    align-items: flex-end;
    align-self: flex-end;
  }
}

.msg_txt_css {
  // padding: 10px;
  max-width: 100%;
  display: inline-block;
  border-radius: 5px;
  // background: white;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  // margin-bottom: 10px;
  line-height: 24px;
  word-break: break-all;
  word-wrap: break-word;
  font-size: 16px;
  color: #1A1A1A;
  // padding: 12px;

}

.msg-bubble--user {
  max-width: 600px;
  width: fit-content;
  padding: 12px 16px;
  background: #f5f5f5;
  border-radius: 8px;
  box-sizing: border-box;
}

.plain-msg-text {
  margin: 0;
  line-height: 24px;
  word-break: break-word;
}

.user-message-text {
  margin: 0;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
}

.quote-reply-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;

  &--user {
    gap: 8px;
    max-width: 600px;
    width: fit-content;
  }

  &--assistant {
    gap: 12px;
    width: 600px;
    max-width: 100%;
  }
}

.ai-reply-header {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ai-reply-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(226, 66, 107, 0.2);
  color: #e2426b;
  font-size: 12px;
  font-family: PingFang SC, PingFangSC-Regular, sans-serif;
  font-weight: 500;
  line-height: 18px;
}

.ai-result-return {
  color: rgba(26, 26, 26, 0.45);
  font-size: 14px;
  font-family: PingFang SC, PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;
}

.ai-reply-status {
  margin: 0;
  width: 100%;
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
}

.ai-reply-status-main {
  color: #1a1a1a;
  font-weight: 600;
}

.ai-reply-status-hint {
  color: rgba(26, 26, 26, 0.45);
  font-weight: 400;
}

.quote-source {
  display: flex;
  align-items: stretch;
  gap: 0;
  width: 100%;
  min-height: 43px;
  border-radius: 8px;
  background: #f4f4f5;
  padding: 10px 12px 10px 0;
  box-sizing: border-box;

  &--user-nested {
    background: #ffffff;
    border: 1px solid #e8e8e8;
    // padding: 10px 12px 10px 0;
    padding: 4px;
    // gap: 8px;
  }

  &--ref {
    background: #f2f2f2;
    // padding: 10px 12px 10px 0;
    padding: 4px;
  }

  &--embedded {
    min-height: 0;
    background: transparent;
    padding: 0 0 0 4px;
    border-radius: 0;
  }
}

.quote-source--user-nested .quote-source-bar,
.quote-source--ref .quote-source-bar {
  flex-shrink: 0;
  border-radius: 2px 0 0 2px;
}

.quote-source-bar {
  width: 3px;
  flex: 0 0 3px;
  align-self: stretch;
  border-radius: 41px;
  background: #d9d9d9;
}

.quote-source-body {
  flex: 1 1 auto;
  min-width: 0;
  padding-left:8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.quote-source-line {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
}

.quote-source-label {
  color: #1a1a1a;
  font-weight: 500;
}

.quote-source-value {
  color: rgba(26, 26, 26, 0.85);
  font-weight: 400;
}

.quote-answer {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.quote-answer-icon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: 3px;
  color: rgba(26, 26, 26, 0.7);
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5;
}

.quote-answer-text {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  line-height: 22px;
  word-break: break-word;
}

.quote-reply-tag {
  font-weight: 500;
  color: #1a1a1a;
}

.quote-reply-content {
  color: #1a1a1a;
  font-weight: 400;
}

.msg_tit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 8px;
  // margin-bottom: 5px;
  background: rgba(226, 66, 107, 0.2);
  border-radius: 8px;
  line-height: 18px;
}

.msg_name {
  color: #e2426b;
  font-size: 12px;
  font-family: PingFang SC, PingFangSC-Regular, sans-serif;
  font-weight: 500;
  line-height: 18px;
}

.msg_btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: calc(100% - 150px);
  // background: white;
  position: relative;
  // padding: 0 10px;
  border-radius: 3px;
  color: #e2426b;
  font-size: 12px;
  font-weight: 600;
  position: relative;
  top: -3px;

  .css_type {
    // width: 100%;
    text-align: center;
    margin-right: 5px;
  }
}

.public_txt_handoff {
  color: #e2426b;
  font-weight: 600;
  cursor: pointer;
}

.li_text_css {
  line-height: 20px;
  margin: 5px 0;
}

.analysis-result {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  .analysis-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 3px;
    border-bottom: 1px solid #eeeeee;
  }

  .analysis-title {
    margin: 0;
    padding: 0;
    color: #262729;
    font-size: 14px;
    font-family: PingFang SC, PingFangSC-Regular, sans-serif;
    font-weight: 500;
    line-height: 22px;
  }

  .analysis-time {
    flex-shrink: 0;
    margin-left: 12px;
    color: #aaadb5;
    font-size: 12px;
    font-family: PingFang SC, PingFangSC-Regular, sans-serif;
    font-weight: 400;
    line-height: 20px;
  }

  .result-note {
    // margin: 4px 0 0;
    padding: 0;
    color: #000;
    font-size: 14px;
    font-family: PingFang SC, PingFangSC-Regular, sans-serif;
    font-weight: 500;
    line-height: 22px;
    white-space: pre-line;
    word-break: break-all;
  }
}

.plain-message-block {
  width: 100%;
}

.plain-message-text {
  margin: 0;
  word-break: break-all;
}

.force-submit-tip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
  border-radius: 8px;
  background: #f4f4f5;
  font-size: 14px;
  line-height: 22px;
}

.force-submit-label,
.force-submit-suffix {
  color: rgba(26, 26, 26, 0.7);
  font-family: PingFang SC, PingFangSC-Regular, sans-serif;
}

.force-submit-label {
  font-weight: 500;
}

.force-submit-suffix {
  font-weight: 400;
}

.force-submit-action {
  border: 0;
  background: transparent;
  padding: 0;
  color: #e2426b;
  font-size: 14px;
  font-family: PingFang SC, PingFangSC-Regular, sans-serif;
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
  transition: color 0.16s ease;

  &:hover {
    color: #e2426b;
    // font-weight: 600;
  }

  &:focus-visible {
    outline: 2px solid rgba(232, 63, 112, 0.28);
    outline-offset: 2px;
    border-radius: 4px;
  }
}

.result-card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 600px;
}

.manual-reply-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  width: 100%;
  box-sizing: border-box;
}

.manual-reply-badge {
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 8px;
  background: #dceafe;
  color: #3479e9;
  font-size: 12px;
  font-family: PingFang SC, PingFangSC-Regular, sans-serif;
  font-weight: 500;
  line-height: 18px;
}

.manual-reply-badge--consultant {
  background: rgba(226, 66, 107, 0.2);
  color: #e2426b;
}

.manual-reply-panel {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background: #f0f7ff;
  box-sizing: border-box;
}

.manual-quote-source {
  display: flex;
  align-items: stretch;
  width: 100%;
  // padding: 12px 12px 12px 0;
  padding: 4px;
  border-radius: 8px;
  background: #e1efff;
  box-sizing: border-box;
}

.manual-reply-card .quote-source-bar {
  flex-shrink: 0;
  border-radius: 2px 0 0 2px;
  background: #3479e9;
}

.manual-quote-content {
  flex: 1 1 auto;
  min-width: 0;
  padding-left: 8px;
}

.manual-quote-line {
  margin: 0;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  word-break: break-word;
}

.manual-quote-line+.manual-quote-line {
  margin-top: 4px;
}

.manual-quote-label {
  color: rgba(26, 26, 26, 0.85);
}

.manual-quote-value {
  color: #1a1a1a;
}

.manual-reply-text {
  margin: 12px 0 0;
  padding: 0;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  word-break: break-word;
}

.result-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 600px;
  border: 1px solid #e1e1e2;
  border-radius: 12px;
  background: #fff;
  padding: 12px;
  box-shadow: 0.5px 0.5px 1.5px rgba(26, 26, 26, 0.08);
  box-sizing: border-box;
}

.card-main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}

.card-con {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  // margin-top: 12px;

}

.card-main .card-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  // margin-top: 16px;
}

.result-card .card-alert {
  align-self: stretch;
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  background: #fef1f1;
  color: #dc2828;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  word-break: break-all;
  white-space: pre-line;
  box-sizing: border-box;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.card-head-left {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  min-width: 0;
}

.badge-row {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 0 10px;
  border: 1px solid rgba(26, 26, 26, 0.12);
  border-radius: 12px;
  background: #fcfcfc;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  box-shadow: 0.5px 0.5px 3px rgba(26, 26, 26, 0.08);
  white-space: nowrap;
}

.badge.status-success {
  border-color: #149041;
  background: #149041;
  color: #fff;
}

.badge.status-error,
.badge.status-fake {
  border-color: #dc2828;
  background: #dc2828;
  color: #fff;
}

.card-time {
  color: rgba(26, 26, 26, 0.36);
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
}

.card-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #7a7a83;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  cursor: pointer;
  flex-shrink: 0;

  i {
    font-size: 16px;
  }
}

.card-title {
  margin: 0;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  word-break: break-all;
}

.card-desc {
  margin: 0;
  color: rgba(26, 26, 26, 0.7);
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  word-break: break-all;
}

.card-meta-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.card-meta-label {
  width: 80px;
  flex-shrink: 0;
  color: #5f5f5f;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.card-meta-value {
  flex: 1;
  min-width: 0;
  color: #000;
  font-size: 14px;
  line-height: 22px;
  word-break: break-all;
}

.card-note {
  padding: 8px;
  border-radius: 8px;
  background: #f4f4f5;
  color: rgba(26, 26, 26, 0.7);
  font-size: 14px;
  line-height: 22px;
  word-break: break-all;
  white-space: pre-line;
}

.card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  width: 100%;
}

.card-actions--end-only {
  justify-content: flex-end;
}

.card-actions__start {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.card-actions__end {
  flex: 0 1 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.card-action {
  flex: 0 0 auto;
  box-sizing: border-box;
  border: 0;
  border-radius: 6px;
  background: transparent;
  padding: 0;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04em;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease;
}

.card-action--outline {
  min-width: 64px;
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  font-weight: 500;
  text-align: center;

  &:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
  }
}

.card-action--link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  color: rgba(26, 26, 26, 0.7);
  font-weight: 400;

  &:hover {
    color: rgba(26, 26, 26, 0.9);
  }

  .card-action-chevron {
    color: #5f5f5f;
  }
}

.card-action--accent {
  min-width: 64px;
  padding: 6px 12px;
  border: 1px solid #e2426b;
  background: #fef1f1;
  color: #e2426b;
  font-weight: 500;
  text-align: center;

  &:hover {
    background: #fde8e8;
    border-color: #d63a61;
  }

  .card-action-chevron {
    color: #e2426b;
  }
}

.card-action-dropdown {
  flex: 0 0 auto;
}

.card-action-dropdown--link {
  display: inline-flex;
  justify-content: flex-start;
}

.card-action--dropdown {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.card-action-chevron {
  font-size: 16px;
  line-height: 1;
}

.details-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  // margin: 16px 0 0;
  border: 0;
  background: transparent;
  padding: 0;
  color: #a9abb0;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
  transition: color 0.16s ease;

  &:hover {
    color: #7e828a;
  }

  &:focus-visible {
    outline: 2px solid rgba(232, 63, 112, 0.28);
    outline-offset: 3px;
    border-radius: 4px;
  }

  .chevron {
    font-size: 16px;
    transition: transform 0.16s ease;
  }

  &[aria-expanded="true"] .chevron {
    transform: rotate(90deg);
  }
}

.details-list-wrap {
  display: grid;
  grid-template-rows: 0fr;
  margin-top: 0;
  overflow: hidden;
  transition: grid-template-rows 0.22s ease, margin-top 0.22s ease;

  &.is-open {
    grid-template-rows: 1fr;
    margin-top: 8px;
  }

  .details-list {
    min-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.18s ease;
  }

  &.is-open .details-list {
    opacity: 1;
    transition: opacity 0.2s ease 0.06s;
  }
}

.details-list {
  padding: 0 0 0 18px;
  font-size: 14px;
  line-height: 22px;
  list-style: disc;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  li {
    // margin: 0 0 8px;
    padding-left: 2px;
  }

  li::marker {
    color: #5f5f5f;
  }

  .details-list-label {
    color: #5f5f5f;
    font-weight: 500;
  }

  .details-list-value {
    color: #a9abb0;
    font-weight: 400;
  }
}

.tip_css {
  font-size: 12px;
  // position: relative;
  // top: -5px;
}

.down_css,
.up_css {
  position: relative;
  flex-shrink: 0;
  height: 0;
  overflow: hidden;
}

.down_css.is-active,
.up_css.is-active {
  height: 64px;
  min-height: 64px;
  overflow: visible;
}

.down_css.is-active {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}

.down_css.is-active /deep/ .el-loading-mask,
.up_css.is-active /deep/ .el-loading-mask {
  display: flex;
  align-items: center;
  justify-content: center;
}

.down_css.is-active /deep/ .el-loading-spinner,
.up_css.is-active /deep/ .el-loading-spinner {
  position: static;
  top: auto;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;

  .el-icon-loading {
    color: #e2426b;
  }
}

.down_css.is-active /deep/ .el-loading-text,
.up_css.is-active /deep/ .el-loading-text {
  margin: 0;
  line-height: 20px;
  color: #e2426b;
}

.wenxian_li_s {
  .wenxian_li {
    font-size: 16px;
    line-height: 24px;
    word-wrap: break-word;
    white-space: normal;

    .li_tit {
      font-weight: 500;
      color: rgb(41, 41, 41);
    }
  }
}

.wenxian_btn {
  margin: auto;
  text-align: center;
  color: white;
  // width: 50%;
  width: 300px;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
  font-size: 13px;
  cursor: pointer;
}

.cite_css {
  border-left: solid 1px #bdb8b8;
  padding-left: 10px;
  margin-left: 3px;
  font-size: 12px !important;
  margin-bottom: 5px;
  position: relative;

  .wenxian_li {
    line-height: 20px !important;
  }

  .quotbox {
    background: #e8e8e9;
    padding: 6px;
    margin-right: 12px;
    border-radius: 4px;
  }
}

.cite_icon {
  position: absolute;
  right: -5px;
  top: -3px;
  font-weight: 500;
  cursor: pointer;
}

.identify_btn_css {
  background-color: #e2426b;
  padding: 6px 10px;
  border-radius: 3px;
  color: white;
  font-weight: 500;
  font-size: 13px;
  margin-left: 10px;
}

.time_css {
  text-align: center;
  color: #636363;
  font-size: 12px;
  margin: 5px;
}

.wenxian_txt_css {
  display: inline-block;
  width: calc(100% - 10px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tab_tag_ {
  display: inline-block;
  text-align: left;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
}

.tab_tag_s {
  position: relative;
  left: 21px;
  width: 302px;
  height: 52px;
  padding: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
  border-radius: 39px;
  background-color: #fff;
  border: 1px solid #e4e4e6;
  overflow: hidden;
  isolation: isolate;

  .tab_tag_slider {
    position: absolute;
    top: 8px;
    left: 8px;
    width: calc((100% - 16px - 4px) / 2);
    height: 36px;
    border-radius: 34px;
    background: #e2426b;
    box-shadow: 0 0 3.1px -1px #e2426b;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    z-index: 0;

    &.is-right {
      transform: translateX(calc(100% + 4px));
    }
  }

  .tab_tag {
    position: relative;
    z-index: 1;
    flex: 1 1 0;
    height: 36px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 34px;
    background: transparent;
    color: #a8aaae;
    font-size: 14px;
    font-family: PingFang SC, PingFangSC-Regular, sans-serif;
    font-weight: 500;
    line-height: 22px;
    cursor: pointer;
    transition: color 0.3s ease;

    .el-icon-warning {
      font-size: 14px;
      color: inherit;
      flex-shrink: 0;
    }
  }

  .tab_tag_tip {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }

  .tag_picked_css {
    color: #fff;
  }
}

.retrieval_css {
  width: 100% !important;

  /deep/ .top {
    background: none !important;
    height: 350px;
  }

  /deep/ .el-textarea__inner {
    background: #fff !important;
  }
}

.dialog_file_css {
  border-radius: var(---8, 8px) !important;

  .el-dialog__header {
    padding: 24px 16px 0px 24px;
  }

  .el-dialog__title {
    color: #000;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    font-style: normal;
  }

  .el-dialog__body {
    padding: 24px 24px 0px 24px;
  }

  .el-dialog__footer {
    padding: 24px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }

  .el-radio__input.is-checked .el-radio__inner {
    color: #e2426b;
    background: #e2426b;
  }

  .el-radio__label {
    color: var(---, #8d8f94);
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: var(---, #262729);
  }

  .el-form-item {
    // gap: 24px;
    margin: 0;
  }
}

.link_css {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.link_url_css {
  width: 100%;
}

.link_url {
  display: flex;
  align-items: center;

  span {
    display: inline-block;
  }

  i {
    display: inline-block;
    cursor: pointer;
  }

  line-height: 24px;

  .url_tit {
    color: var(---, #6b6e73);
  }

  .inputText {
    padding: 0px 24px;
    border-radius: 5px;
    height: 24px;
    color: var(---600, #3c68f8);
    flex: 1 0 0;

    span {
      margin: 0 0px 0 0;
      text-decoration: underline;
      overflow: hidden;
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}

.operate_txt {
  color: #c8c8c8;
  // margin: 0 20px 0 0;
  position: absolute;
  bottom: 10px;
  left: -220px;
}

.message_list_css {
  display: flex;
  width: @chat-content-width;
  max-width: 100%;
  flex-direction: column;
  gap: 32px;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
}
.message_list_css_inner{
  display: flex;
  width: @chat-content-width;
  max-width: 100%;
  flex-direction: column;
  gap: 32px;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  box-sizing: border-box;
}
</style>
<style>
.code_css {
  z-index: 5000 !important;
}

.card-err-feedback-dropdown {
  text-align: left;
}

.card-err-feedback-dropdown .el-dropdown-menu__item {
  text-align: left;
}

.processing-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.processing-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 22px;
  margin-bottom: 0;
  color: rgba(26, 26, 26, 0.7);
  font-size: 14px;
  line-height: 22px;
}

.processing-divider {
  width: 100%;
  height: 1px;
  background: #e8e8e8;
}

.processing-hint {
  margin: 0;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.processing-text {
  position: relative;
  display: inline-block;
  font-weight: 500;
}

.conversation-item.is-processing .processing-text,
.conversation-item.parsing .processing-text,
.conversation-item.analysis-ready .processing-text,
.conversation-item.results-running .processing-text {
  overflow: hidden;
}

.conversation-item.is-processing .processing-text::after,
.conversation-item.parsing .processing-text::after,
.conversation-item.analysis-ready .processing-text::after,
.conversation-item.results-running .processing-text::after {
  content: "";
  position: absolute;
  inset: -2px 0;
  pointer-events: none;
  background: linear-gradient(100deg,
      transparent 0%,
      transparent 28%,
      rgba(255, 255, 255, 0.15) 38%,
      rgba(232, 63, 112, 0.24) 50%,
      rgba(255, 255, 255, 0.26) 62%,
      transparent 72%,
      transparent 100%);
  mix-blend-mode: screen;
  transform: translateX(-130%);
  animation: text-sheen 1.8s ease-in-out infinite;
}

.dot {
  animation: pulse-dot 1.2s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.18s;
}

.dot:nth-child(3) {
  animation-delay: 0.36s;
}

@keyframes text-sheen {
  0% {
    transform: translateX(-130%);
  }

  58%,
  100% {
    transform: translateX(130%);
  }
}

@keyframes pulse-dot {

  0%,
  80%,
  100% {
    opacity: 0.28;
  }

  40% {
    opacity: 1;
  }
}

.source-link-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.source-link-dialog .el-dialog__header {
  padding: 24px 24px 0;
}

.source-link-dialog .el-dialog__title {
  display: block;
  padding-right: 28px;
  line-height: normal;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
}

.source-link-dialog .el-dialog__title,
.source-link-dialog-title {
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}

.source-link-dialog--plain .el-dialog__body {
  padding-top: 16px;
}

.source-link-dialog .el-dialog__headerbtn {
  top: 24px;
  right: 24px;
}

.source-link-dialog .el-dialog__body {
  padding: 16px 24px 24px;
}

.source-link-dialog-form .el-form-item {
  margin-bottom: 0;
}

.source-link-dialog-form .source-link-dialog-field {
  margin-bottom: 0;
}

.source-link-dialog-hint {
  margin: 16px 0 0;
  color: rgba(26, 26, 26, 0.55);
  font-size: 14px;
  line-height: 22px;
}

.source-link-dialog-field .el-textarea__inner {
  min-height: 88px;
  padding: 10px 12px;
  border: 1px solid #e1e1e2;
  border-radius: 8px;
  background: #fff;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 22px;
  resize: none;
  box-shadow: none;
}
lian
.source-link-dialog-field .el-textarea__inner:focus {
  border-color: #e2426b;
}

.source-link-dialog-field .el-textarea__inner::placeholder {
  color: rgba(26, 26, 26, 0.36);
}

.source-link-dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.source-link-dialog-btn {
  min-width: 72px;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.source-link-dialog-btn--back {
  color: #262729;
  background: #fff;
  border: 1px solid #e1e1e2;
}

.source-link-dialog-btn--back:hover,
.source-link-dialog-btn--back:focus {
  color: #262729;
  background: #f8f8f8;
  border-color: #d5d5d6;
}

.source-link-dialog-btn--confirm {
  color: #fff;
  background: #e2426b;
  border: 1px solid #e2426b;
}

.source-link-dialog-btn--confirm:hover,
.source-link-dialog-btn--confirm:focus {
  color: #fff;
  background: #d63a61;
  border-color: #d63a61;
}

.link-unreachable-desc {
  margin: 0 0 16px;
  color: rgba(26, 26, 26, 0.55);
  font-size: 14px;
  line-height: 22px;
}

.link-unreachable-dialog .link-unreachable-field+.link-unreachable-field {
  margin-top: 12px;
}

.link-unreachable-dialog .source-link-dialog-field .el-input__inner {
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  border: 1px solid #e1e1e2;
  border-radius: 8px;
  background: #fff;
  color: #1a1a1a;
  font-size: 14px;
  box-shadow: none;
}

.link-unreachable-dialog .source-link-dialog-field .el-input__inner:focus {
  border-color: #e2426b;
}

.link-unreachable-dialog .source-link-dialog-field .el-input__inner::placeholder {
  color: rgba(26, 26, 26, 0.36);
}

.link-unreachable-dialog .el-input.is-disabled .el-input__inner {
  color: rgba(26, 26, 26, 0.55);
  background: #fff;
  cursor: default;
}

.link-unreachable-dialog .el-input__suffix {
  right: 12px;
}

.link-unreachable-send-code {
  padding: 0;
  border: none;
  background: transparent;
  color: #e2426b;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
  white-space: nowrap;
}

.link-unreachable-send-code:disabled {
  color: rgba(226, 66, 107, 0.45);
  cursor: not-allowed;
}

.link-unreachable-dialog-body .source-link-dialog-footer {
  margin-top: 24px;
}

.recommend_css.dialog_file_css {
  overflow: hidden;
  border-radius: 8px !important;
}

.recommend_css .el-dialog__close {
  width: 16px;
  height: 16px;
  font-weight: 600;
}

.recommend_css .el-dialog__body {
  padding: 0;
  overflow: hidden;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.similar-recommend-body {
  min-height: 420px;
  box-sizing: border-box;
  overflow: hidden;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.recommend_css .similar-recommend-body .el-loading-mask {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.recommend_css .prompt_txt {
  display: flex;
  height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: #f3f3f3;
  padding: 0 24px;
  margin: 8px 0 0;
}

.recommend_css .prompt_txt_css {
  color: #666b75;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}

.recommend_css .canto_css {
  padding: 32px 24px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  height: 310px;
  overflow-x: hidden;
  overflow-y: auto;
}

.recommend_css .canto_css::-webkit-scrollbar {
  display: none;
}

.recommend_css .canto_li {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
}

.recommend_css .canto_tit {
  display: flex;
  width: 96px;
  align-items: center;
  gap: 16px;
  color: #6b6e73;
  font-weight: 600;
  line-height: 24px;
  flex-shrink: 0;
}

.recommend_css .canto_con {
  color: #262729;
  font-size: 14px;
  font-weight: 500;
  width: calc(100% - 96px);
  line-height: 24px;
  word-break: break-word;
}

.recommend_css .isoa_css {
  display: flex;
  padding: 4px 6px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #f68212;
  margin-left: 10px;
  flex-shrink: 0;
}

.recommend_css .isoa_txt {
  color: #000;
  font-size: 10px;
  font-weight: 900;
  line-height: normal;
}

.recommend_css .canto_handoff {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  color: #000;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  padding: 24px 0;
}

.recommend_css .canto_none {
  display: flex;
  padding: 24px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  color: #aaadb5;
  font-weight: 600;
  line-height: 24px;
  height: 350px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.recommend_css .toggle-btn {
  color: #6b8cfa;
  cursor: pointer;
}

.recommend_css .submit_btn_css {
  display: flex;
  padding: 0 24px 24px;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

.recommend_css .submit_btn {
  display: flex;
  padding: 6px 14px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: #e2426b;
  line-height: 22px;
  color: #fff;
  cursor: pointer;
}
</style>